import React, { useState, useEffect, useRef } from 'react';
import { Search, Plus, X, TrendingUp, Shield, ArrowRight, Cpu, BarChart3, CheckCircle, Sparkles, AlertCircle, Loader, HelpCircle, FileSpreadsheet, FileText,Banknote,Building,ShieldUser,Heart } from 'lucide-react';
import api from '../services/api';
import LeadModal from './FloatingElements';
import ProductComparison from './ProductComparison';
import TooltipPortal from './TooltipPortal';
import { useParams, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { saveContact } from '../services/firebase/contactService';
import OptimizedSearchAutocomplete from './OptimizedSearchAutocomplete';
const NON_SECTORAL_COMPANIES = [
  'אנליסט',
  'אלטשולר שחם',
  'אינפיניטי',
  'הפניקס',
  'הראל',
  'ילין לפידות',
  'כלל',
  'מגדל',
  'מור',
  'מיטב',
  'מנורה'
];
// תיקון מיפוי קטגוריות למזהה API
const getCategoryApiId = (categoryKey) => {
  const mapping = {
    'study-funds': 'study-funds',
    'pension-savings': 'pension-savings', 
    'investment-funds': 'investment-funds',
    'pension-plans': 'pension-plans',
    'insurance-management': 'insurance-management',
    'savings-policies': 'insurance-savings',
    'child-savings': 'child-savings'
  };
  
  return mapping[categoryKey] || categoryKey;
};
const RISK_LEVEL_TO_STOCK_EXPOSURE = {
  1: { min: 0, max: 10 },   // סולידי
  2: { min: 10, max: 31 },  // סולידי-מאוזן
  3: { min: 32, max: 53 },  // מאוזן
  4: { min: 53, max: 65 },  // מאוזן-אגרסיבי
  5: { min: 65, max: 100 }  // אגרסיבי
};
// פונקציה לזיהוי סוג המוצר
const getProductType = (product) => {
  const source = product._sourceLabel || product.source || '';
  const name = product.FUND_NAME || product.name || '';
  const classification = product.FUND_CLASSIFICATION || product.classification || '';

  switch (source) {
    case 'גמל נט':
    case 'gamal-net':
      if (name.includes('השתלמות')) return 'קרן השתלמות';
      if (name.includes('ילד')) return 'חסכון לילד';
      if (classification.includes('השקעה')) return 'קופת גמל להשקעה';
      return 'קופת גמל';
    case 'פנסיה נט':
    case 'pension-net': 
      return 'קרן פנסיה';
    case 'ביטוח נט':
    case 'insurance-net': 
      if (product.isSavingsPolicy === true) {
        return 'פוליסת חיסכון';
      } else if (product.isManagementFund === true) {
        return 'ביטוח מנהלים';
      }
      return 'מוצר ביטוח';
    default: 
      return source || 'לא מוגדר';
  }
};

// פונקציה לקביעת קטגוריה של מוצר לניווט
const getProductCategory = (product) => {
  const source = product.source || product._source || product._sourceLabel || '';
  const name = product.name || product.FUND_NAME || '';
  const classification = product.classification || product.FUND_CLASSIFICATION || '';
  
  switch (source) {
    case 'gamal-net':
    case 'גמל נט':
      if (name.includes('השתלמות')) return 'study-funds';
      if (name.includes('ילד')) return 'child-savings';
      if (classification.includes('השקעה')) return 'investment-funds';
      return 'pension-savings';
    case 'pension-net':
    case 'פנסיה נט':
      return 'pension-plans';
    case 'insurance-net':
    case 'ביטוח נט':
      if (product.isSavingsPolicy === true) {
        return 'savings-policies';
      } else if (product.isManagementFund === true) {
        return 'insurance-management';
      }
      return 'savings-policies';
    default:
      return null;
  }
};

const filterBySelectedCategory = (results, selectedCategory) => {
  console.log(`🔍 filterBySelectedCategory called with ${results?.length} results for category: ${selectedCategory}`);
  
  if (!selectedCategory || !results) {
    return results || [];
  }

  const filtered = results.filter(item => {
    const source = item._sourceLabel || item.source || '';
    const name = item.FUND_NAME || item.name || '';
    const classification = item.FUND_CLASSIFICATION || item.classification || '';
    
    let shouldInclude = false;
    
    switch (selectedCategory) {
      case 'study-funds':
        shouldInclude = name.includes('השתלמות');
        break;
      
      case 'child-savings':
        shouldInclude = name.includes('ילד') || 
                       classification.includes('ילד') ||
                       (item.fundInfo?.targetPopulation && item.fundInfo.targetPopulation.includes('ילד'));
        break;
      
      case 'investment-funds':
        shouldInclude = classification.includes('השקעה');
        break;
      
      case 'pension-savings':
        const isFromGamal = source.includes('גמל') || source.includes('gamal');
        const hasSpecialType = name.includes('השתלמות') || name.includes('ילד') || classification.includes('השקעה');
        shouldInclude = isFromGamal && !hasSpecialType;
        break;
      
      case 'pension-plans':
        shouldInclude = source.includes('פנסיה') || source.includes('pension');
        break;
      
      case 'insurance-management':
        const isInsuranceSource = source.includes('ביטוח') || source.includes('insurance');
        shouldInclude = isInsuranceSource && !item.isSavingsPolicy;
        break;
      
      case 'savings-policies':
        shouldInclude = item.isSavingsPolicy === true;
        break;
      
      default:
        shouldInclude = true;
    }
    
    return shouldInclude;
  });
return filtered.filter(item => item.isActive !== false);
};


const RiskLevelLegend = ({ filteredProducts = [] }) => {
  const riskLevels = [
    { 
      level: 1, 
      name: 'סולידי', 
      description: '0%-10% מניות',
      color: 'emerald'
    },
    { 
      level: 2, 
      name: 'סולידי-מאוזן', 
      description: 'עד 25% מניות',
      color: 'blue'
    },
    { 
      level: 3, 
      name: 'מאוזן', 
      description: 'עד 53% מניות',
      color: 'amber'
    },
    { 
      level: 4, 
      name: 'מאוזן-אגרסיבי', 
      description: 'עד 65% מניות',
      color: 'orange'
    },
    { 
      level: 5, 
      name: 'אגרסיבי', 
      description: '65%-100% מניות',
      color: 'red'
    }
  ];

  // קבלת הרמות הפעילות
  const activeLevels = new Set();
  filteredProducts.forEach(product => {
    if (product.riskLevel?.level) {
      activeLevels.add(product.riskLevel.level);
    }
  });

  const getColorClasses = (color, isActive) => {
    const colors = {
      emerald: {
        bg: isActive ? 'bg-emerald-100' : 'bg-gray-50',
        dot: 'bg-emerald-500',
        text: isActive ? 'text-emerald-800' : 'text-gray-600'
      },
      blue: {
        bg: isActive ? 'bg-blue-100' : 'bg-gray-50',
        dot: 'bg-blue-500',
        text: isActive ? 'text-blue-800' : 'text-gray-600'
      },
      amber: {
        bg: isActive ? 'bg-amber-100' : 'bg-gray-50',
        dot: 'bg-amber-500',
        text: isActive ? 'text-amber-800' : 'text-gray-600'
      },
      orange: {
        bg: isActive ? 'bg-orange-100' : 'bg-gray-50',
        dot: 'bg-orange-500',
        text: isActive ? 'text-orange-800' : 'text-gray-600'
      },
      red: {
        bg: isActive ? 'bg-red-100' : 'bg-gray-50',
        dot: 'bg-red-500',
        text: isActive ? 'text-red-800' : 'text-gray-600'
      }
    };
    return colors[color];
  };

  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-100 p-4 max-w-xs">
      <div className="flex items-center gap-2 mb-3">
        <Shield className="h-4 w-4 text-blue-600" />
        <h4 className="font-semibold text-gray-900 text-sm">רמות סיכון</h4>
      </div>
      
      <div className="space-y-2">
        {riskLevels.map((risk) => {
          const isActive = activeLevels.has(risk.level);
          const colors = getColorClasses(risk.color, isActive);
          
          return (
            <div 
              key={risk.level}
              className={`flex items-center gap-2 p-2 rounded-md transition-all duration-200 ${colors.bg} ${
                isActive ? 'ring-1 ring-blue-200' : ''
              }`}
            >
              <div className={`w-2 h-2 rounded-full ${colors.dot} flex-shrink-0`}></div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <span className={`font-medium text-xs ${colors.text}`}>
                    {risk.level}. {risk.name}
                  </span>
                  {isActive && (
                    <span className="bg-blue-500 text-white text-xs px-1.5 py-0.5 rounded-full font-medium">
                      ✓
                    </span>
                  )}
                </div>
                <div className={`text-xs ${isActive ? 'text-gray-600' : 'text-gray-500'} mt-0.5`}>
                  {risk.description}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      
      <div className="mt-3 p-2 bg-blue-50 rounded-md">
        <p className="text-xs text-blue-700">
          <strong>💡 טיפ:</strong> בחר רמה בהתאם לגיל ויעדיך
        </p>
      </div>
    </div>
  );
};
const RouteScanner = () => {
  const { category } = useParams();
  const navigate = useNavigate(); // הוסף את השורה הזאת
  const [activeTab, setActiveTab] = useState(category || 'study-funds');
  const [searchTerm, setSearchTerm] = useState('');
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [specializations, setSpecializations] = useState([]);
  const [categoryClassifications, setCategoryClassifications] = useState([]);
  const [sortBy, setSortBy] = useState('year1');
  const [sortOrder, setSortOrder] = useState('desc');
  const [reportPeriod, setReportPeriod] = useState(null);
  const [showComparison, setShowComparison] = useState(false);
  const [showRiskTooltip, setShowRiskTooltip] = useState(false);
const [filterNonSectoral, setFilterNonSectoral] = useState(false);
  // הצעות חיפוש
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const searchRef = useRef(null);
  const [riskLevels, setRiskLevels] = useState([]);
 const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);
 const [currentLeadContext, setCurrentLeadContext] = useState(null);
const [isMobile, setIsMobile] = useState(false);
const riskTooltipRef = useRef(null);
const [searchableSelectFields, setSearchableSelectFields] = useState({});
const [searchInputValues, setSearchInputValues] = useState({});
const [showSearchModal, setShowSearchModal] = useState(false);
const [activeSearchField, setActiveSearchField] = useState(null);
const openLeadModal = () => {
  const sourceContext = {
    source: 'RouteScanner',
    category: category,
    userLocation: 'Israel',
    
    // פרטי המוצר הנוכחי
    productId: null,
    productName: null,
    
    // פרטי הקרן המובילה (מה-bestMatchingSpec)

  };

  setCurrentLeadContext(sourceContext);
  setIsLeadModalOpen(true);
};
const INVESTMENT_TRACKS = {
  'all': {
    categories: [
      // קטגוריות עיקריות
      { name: 'מניות', variants: ['מניות', 'מסלול מניות', 'מסלול מניות סחיר','מניות סחיר',] },
  {name:'עוקב מדדי מניות', variants: ['עוקב מדדי מניות', 'עוקב מדד מניות', 'עוקב מדד מניות s&p 500', 'עוקב מדד מניות s&p']},
    
      { name: 'מעורב', variants: ['מעורב', 'משולב', 'אג"ח עם מניות', 'ישראלי ואג"ח עם מניות'] },
      { name: 'כספי/שקלי', variants: ['כספי', 'שקלי', 'מסלול כספי','שיקלי', 'מסלול כספי (שקלי)'] },
      { name: 'עוקב מדדים', variants: ['עוקב מדדים', 'עוקב מדד', 'עוקב מדדי', 'עוקב מדד s&p 500','אג"ח', 'מסלול אג"ח', 'אג"ח ממשלתיות', 'מסלול אג"ח ממשלתיות','עוקב מדדים-גמיש'] },
      { name: 'הלכתי', variants: ['הלכה', 'הלכתי', 'מסלול הלכה', 'שריעה', 'מסלול שריעה'] },
    { name: 'קיימות', variants: ['קיימות', 'מסלול קיימות', 'טבעתי', 'מסלול טבעתי'] },
      { name: 'כללי', variants: ['כללי', 'מסלול כללי'] }
    ]
  }
};
const categorizeTracks = (tracks) => {
  const categorized = [];
  const usedTracks = new Set();
  
  INVESTMENT_TRACKS.all.categories.forEach(category => {
    let hasMatch = false;
    tracks.forEach(track => {
      if (category.variants.some(variant => 
        track.toLowerCase().includes(variant.toLowerCase()) ||
        variant.toLowerCase().includes(track.toLowerCase())
      ) && !usedTracks.has(track)) {
        hasMatch = true;
        usedTracks.add(track);
      }
    });
    
    if (hasMatch) {
      categorized.push(category.name);
    }
  });
  
  // הוסף מסלולים שלא נקטלגו
  tracks.forEach(track => {
    if (!usedTracks.has(track)) {
      categorized.push(track);
    }
  });
  
  return categorized;
};
// זיהוי מובייל
useEffect(() => {
  const checkMobile = () => {
    setIsMobile(window.innerWidth < 768);
  };
  
  checkMobile();
  window.addEventListener('resize', checkMobile);
  
  return () => window.removeEventListener('resize', checkMobile);
}, []);
const [selectedRanges, setSelectedRanges] = useState({
  foreign: { min: 0, max: 100 },
  currency: { min: 0, max: 100 }
});
const [exposureRanges, setExposureRanges] = useState({
  foreign: { min: 0, max: 100 },
  currency: { min: 0, max: 100 }
});
const [stockExposureRange, setStockExposureRange] = useState({
  min: 0,
  max: 100
});

  // הגדרת הקטגוריות
const productCategories = {
  'study-funds': {
    title: 'קרנות השתלמות',
    icon: BarChart3, // מ-savingsCategories
    gradient: 'from-blue-500 to-blue-600', // מותאם לצבע המקורי
    filters: ['fundName', 'company', 'stockExposure', 'foreignExposure', 'currencyExposure', 'primaryInvestment']
  },
  'pension-savings': {
    title: 'קופות גמל',
    icon: Banknote, // מ-savingsCategories
    gradient: 'from-green-500 to-green-600', // מותאם לצבע המקורי
    filters: ['fundName', 'fundType', 'stockExposure', 'foreignExposure', 'currencyExposure', 'company', 'primaryInvestment']
  },
  'investment-funds': {
    title: 'גמל להשקעה',
    icon: TrendingUp, // נשאר אותו דבר - תואם לsavingsCategories
    gradient: 'from-purple-500 to-purple-600', // מותאם לצבע המקורי
    filters: ['fundName', 'company', 'stockExposure', 'foreignExposure', 'currencyExposure', 'investmentTrack']
  },
  'pension-plans': {
    title: 'קרנות פנסיה',
    icon: Building, // מ-savingsCategories
    gradient: 'from-red-500 to-red-600', // מותאם לצבע המקורי
    filters: ['fundName', 'company', 'stockExposure', 'foreignExposure', 'currencyExposure', 'pensionType'] 
  },
  'insurance-management': {
    title: 'ביטוח מנהלים',
    icon: ShieldUser, // מ-savingsCategories
    gradient: 'from-teal-500 to-teal-600', // מותאם לצבע המקורי
    filters: ['policyName', 'establishmentPeriod', 'stockExposure', 'foreignExposure', 'currencyExposure', 'company']
  },
  'savings-policies': {
    title: 'פוליסות חיסכון',
    icon: Shield, // מ-savingsCategories (insurance-savings)
    gradient: 'from-orange-500 to-orange-600', // מותאם לצבע המקורי
    filters: ['policyName', 'company', 'stockExposure', 'foreignExposure', 'currencyExposure', 'investmentTrack']
  },
  'child-savings': {
    title: 'חיסכון לילד',
    icon: Heart, // מ-savingsCategories
    gradient: 'from-pink-500 to-pink-600', // מותאם לצבע המקורי
    filters: ['fundName', 'company', 'stockExposure', 'foreignExposure', 'currencyExposure', 'investmentTrack']
  }
};
// הסרנו את syncRiskLevelWithStockExposure כי עכשיו רמת סיכון וחשיפת מניות הם אותו שדה
// עדכן את filterFields להיות פונקציה דינמית:
const getFilterFields = () => ({
  fundName: { label: 'שם קופה/קרן או מזהה', type: 'search', placeholder: 'חפש לפי שם או מזהה...' },
  policyName: { label: 'שם פוליסה או מזהה', type: 'search', placeholder: 'חפש לפי שם פוליסה או מזהה...' },
  fundType: { label: 'סוג קופה', type: 'select' },
  company: { label: 'חברה מנהלת', type: 'select' },
  primaryInvestment: { label: 'מסלול השקעה ראשי', type: 'select' },
  investmentTrack: { 
    label: 'מסלול השקעה', 
    type: 'select',
      savingsPolicyTracks: [
        'כל המסלולים',
        'מסלול כללי',
        'מסלול עוקב מדד s&p 500',
        'מסלול כספי (שקלי)',
        'מסלול ישראלי ואג"ח עם מניות',
        'מסלול אג"ח ממשלתיות',
        'מסלול ישראלי ואג"ח',
        'מסלול מניות',
        'מסלול משולב סחיר',
        'מסלול אג"ח ממשלתיות סחיר',
        'מסלול אג"ח סחיר',
        "עוקב מדדים - גמיש",
        'מסלול סחיר - אג"ח עם מניות (עד 25% מניות)',
        'מסלול מניות סחיר',
        'מסלול עוקב מדדים - גמיש',
        'מסלול עוקב מדדי אג"ח ממשלתיות',
        'מסלול עוקב מדדי אג"ח',
        'מסלול עוקב מדדים - אג"ח עם מניות (עד 25% מניות)',
        'מסלול עוקב מדדי מניות',
        'מסלול הלכה',
        'מסלול שריעה',
        'מסלול קיימות',
      
      ]
  },
    pensionType: { 
    label: 'סוג פנסיה', 
    type: 'select',
    options: ['מקיפה', 'משלימה']
  },
  establishmentPeriod: { label: 'תקופת הקמה', type: 'select', options: ['1990-1991', '1992-2003', '2004 והלאה'] },
  fundSize: { label: 'גודל הקופה', type: 'select', options: ['עד 250 מיליון', 'עד 500 מיליון', 'עד 700 מיליון', 'עד מיליארד', 'מעל מיליארד'] },
foreignExposure: { 
  label: 'חשיפה לחו"ל (%)', 
  type: 'exposureSelect',
  options: [
    { label: 'כל הטווחים', value: 'all' },
    { label: '✏️ בחר טווח מותאם אישית', value: 'custom' },
    { label: 'חשיפה נמוכה (0-10%)', value: { min: 0, max: 10 } },
    { label: 'חשיפה בינונית-גבוהה (11-75%)', value: { min: 11, max: 75 } },
    { label: 'חשיפה גבוהה (76% ומעלה)', value: { min: 76, max: 100 } }
  ],
  min: 0,
  max: 100
},
stockExposure: { 
  label: 'רמת סיכון - חשיפה למניות (%)', 
  type: 'exposureSelect',
  options: [
    { label: 'כל הטווחים', value: 'all' },
    { label: '✏️ בחר טווח מותאם אישית', value: 'custom' },
    { label: 'סולידי (0-10%) - רמת סיכון 1 מתוך 5', value: { min: 0, max: 10 }, riskLevel: 1 },
    { label: 'סולידי-מאוזן (10.01-31%) - רמת סיכון 2 מתוך 5', value: { min: 10, max: 31 }, riskLevel: 2 },
    { label: 'מאוזן (31.01-53%) - רמת סיכון 3 מתוך 5', value: { min: 31.01, max: 53 }, riskLevel: 3 },
    { label: 'מאוזן-אגרסיבי (53.01-65%) - רמת סיכון 4 מתוך 5', value: { min: 53.01, max: 65 }, riskLevel: 4 },
    { label: 'אגרסיבי (65.01-100%) - רמת סיכון 5 מתוך 5', value: { min: 65.01, max: 100 }, riskLevel: 5 }
  ],
  min: 0,
  max: 100
},
currencyExposure: { 
  label: 'חשיפה למט"ח (%)', 
  type: 'exposureSelect',
  options: [
    { label: 'כל הטווחים', value: 'all' },
    { label: '✏️ בחר טווח מותאם אישית', value: 'custom' },
    { label: 'חשיפה נמוכה (0-10%)', value: { min: 0, max: 10 } },
    { label: 'חשיפה בינונית (11-35%)', value: { min: 11, max: 35 } },
    { label: 'חשיפה גבוהה (36% ומעלה)', value: { min: 36, max: 100 } }
  ],
  min: 0,
  max: 100
}
});


const currentCategory = productCategories[activeTab] || productCategories['study-funds'];
// עדכון activeTab כאשר משתנה הפרמטר מה-URL
useEffect(() => {
  if (category && category !== activeTab) {
    setActiveTab(category);
  }
}, [category]);
  // טעינת נתונים בהתחלה ובשינוי קטגוריה
  useEffect(() => {
    loadCategoryData();
  }, [activeTab]);

  // סינון מוצרים לפי חיפוש ופילטרים
useEffect(() => {
  applyFilters();
}, [allProducts, searchTerm, filters, sortBy, sortOrder, filterNonSectoral]);

  // חיפוש הצעות עם סינון חכם
  // useEffect(() => {
  //   const searchForSuggestions = async () => {
  //     if (searchTerm.trim().length < 2) {
  //       setSuggestions([]);
  //       setShowSuggestions(false);
  //       return;
  //     }

  //     setLoadingSuggestions(true);
  //     try {
  //       const API_BASE = 'https://us-central1-savings-comparison-system.cloudfunctions.net';
  //       const params = new URLSearchParams({
  //         query: searchTerm.trim(),
  //         limit: 20
  //       });

  //       const response = await fetch(`${API_BASE}/searchAllSources?${params.toString()}`);
  //       const result = await response.json();

  //       if (result.success && result.results && result.results.length > 0) {
  //         const filteredResults = filterBySelectedCategory(result.results, activeTab);
          
  //         const processedSuggestions = filteredResults.slice(0, 6).map(item => ({
  //           id: item.FUND_ID?.toString() || item.id?.toString() || '',
  //           name: item.FUND_NAME || item.name || 'שם לא זמין',
  //           company: item.PARENT_COMPANY_NAME || item.MANAGING_CORPORATION || item.CONTROLLING_CORPORATION || item.company || 'חברה לא ידועה',
  //           source: item._sourceLabel || item.source || '',
  //           productType: getProductType(item),
  //           year1Return: parseFloat(item.YEAR_TO_DATE_YIELD || item.returns?.year1 || 0),
  //           fullData: item
  //         }));

  //         setSuggestions(processedSuggestions);
  //         setShowSuggestions(true);
  //       } else {
  //         setSuggestions([]);
  //         setShowSuggestions(false);
  //       }
  //     } catch (error) {
  //       console.error('❌ Error fetching suggestions:', error);
  //       setSuggestions([]);
  //     } finally {
  //       setLoadingSuggestions(false);
  //     }
  //   };

  //   const timeoutId = setTimeout(searchForSuggestions, 300);
  //   return () => clearTimeout(timeoutId);
  // }, [searchTerm, activeTab]);

  // טיפול במקלדת
  const handleKeyDown = (e) => {
    if (!showSuggestions || suggestions.length === 0) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setSelectedIndex(prev => (prev < suggestions.length - 1 ? prev + 1 : -1));
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedIndex(prev => (prev > -1 ? prev - 1 : suggestions.length - 1));
        break;
      case 'Enter':
        e.preventDefault();
        if (selectedIndex >= 0 && suggestions[selectedIndex]) {
          selectSuggestion(suggestions[selectedIndex]);
        } else {
          handleTextSearch();
        }
        break;
      case 'Escape':
        setShowSuggestions(false);
        setSelectedIndex(-1);
        break;
    }
  };
// עדכון URL בעת מעבר להשוואה
const goToComparison = () => {
  if (selectedProducts.length < 2) {
    alert('יש לבחור לפחות 2 מוצרים להשוואה');
    return;
  }
  
  // יצירת URL עם מזהי המוצרים
  const fundIds = selectedProducts.map(p => p.id).join('-');
  const comparisonUrl = `/route-scanner/compare/${fundIds}`;
  
  // ניווט עם העברת המוצרים
  navigate(comparisonUrl, { 
    state: { selectedProducts } 
  });
};
  // בחירת הצעה
  const selectSuggestion = (suggestion) => {
    setSearchTerm(suggestion.name);
    setShowSuggestions(false);
    setSelectedIndex(-1);
    // הצגת הנתונים בטבלה
    const transformedData = transformSearchResult(suggestion.fullData);
    setFilteredProducts([transformedData]);
  };

  // סגירת הצעות בלחיצה מחוץ לקומפוננט
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
        setSelectedIndex(-1);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const loadCategoryData = async () => {
    try {
      setLoading(true);
      
      const apiCategoryId = getCategoryApiId(activeTab);
      console.log(`🔍 Loading data for ${activeTab} -> ${apiCategoryId}`);
      
      const products = await api.getProductsByCategory(apiCategoryId, { limit: 2000 });
      console.log(`📊 Loaded ${products.length} products for ${apiCategoryId}`);
      
      if (!products || products.length === 0) {
        console.log(`⚠️ No products found for ${apiCategoryId}`);
        setAllProducts([]);
        setFilteredProducts([]);
        setCompanies([]);
        setSpecializations([]);
        setCategoryClassifications([]);
        return;
      }
      
      const transformedProducts = products.map(item => ({
        id: item.FUND_ID?.toString() || item.id?.toString() || '',
        name: item.FUND_NAME || item.name || 'שם לא זמין',
        company: item.PARENT_COMPANY_NAME || item.MANAGING_CORPORATION || item.CONTROLLING_CORPORATION || item.company || 'חברה לא ידועה',
        classification: item.FUND_CLASSIFICATION || item.classification || '',
          riskLevel: item.riskLevel || null,
  exposures: item.exposures || null,
    isComplementaryPension: item.isComplementaryPension || false,
      isComprehensivePension: item.isComprehensivePension || false,
      pensionProductType: item.pensionProductType || null,
      
        returns: {
          month1: parseFloat(item.MONTH_1_YIELD || item.returns?.month1 || 0),
          ytd: parseFloat(item.YEAR_TO_DATE_YIELD || item.returns?.ytd || 0),
          year1: parseFloat(item.YEAR_1_YIELD || item.returns?.year1 || 0),
          year2: parseFloat(item.YEAR_2_YIELD || item.returns?.year2 || 0),
          year3: parseFloat(item.YEAR_3_YIELD || item.returns?.year3 || 0),
          year4: parseFloat(item.YEAR_4_YIELD || item.returns?.year4 || 0),
          year5: parseFloat(item.YEAR_5_YIELD || item.returns?.year5 || 0)
        },
        fees: {
          management: parseFloat(item.MANAGEMENT_FEE || item.fees?.management || 0),
          deposit: parseFloat(item.fees?.deposit || 0)
        },
        totalAssets: parseFloat(item.TOTAL_ASSETS || item.totalAssets || 0),
        source: item._source || 'government-api',
        sourceLabel: item._sourceLabel || 'נתונים ממשלתיים',
        isActive: item.isActive !== false,
        activityStatus: item.activityStatus || 'פעילה',
        reportPeriod: item.reportPeriod,
        originalData: item
      }));

     const activeProducts = transformedProducts.filter(product => product.isActive === true);

setAllProducts(activeProducts); 
const uniqueRiskLevels = [...new Set(
  activeProducts
    .filter(p => p.riskLevel?.level && p.riskLevel?.name)
    .map(p => ({
      level: p.riskLevel.level,
      name: p.riskLevel.name,
      displayText: `${p.riskLevel.level} - ${p.riskLevel.name}`
    }))
    .map(r => r.displayText)
)].sort((a, b) => {
  const aLevel = parseInt(a.charAt(0));
  const bLevel = parseInt(b.charAt(0));
  return aLevel - bLevel;
});

setRiskLevels(uniqueRiskLevels);

// חשב טווחי חשיפה אמיתיים
const validForeignExposures = activeProducts
  .map(p => p.exposures?.foreign)
  .filter(val => val !== null && val !== undefined && !isNaN(val));

const validCurrencyExposures = activeProducts
  .map(p => p.exposures?.currency)  
  .filter(val => val !== null && val !== undefined && !isNaN(val));

if (validForeignExposures.length > 0) {
  setExposureRanges(prev => ({
    ...prev,
    foreign: {
      min: Math.floor(Math.min(...validForeignExposures)),
      max: Math.ceil(Math.max(...validForeignExposures))
    }
  }));
}

if (validCurrencyExposures.length > 0) {
  setExposureRanges(prev => ({
    ...prev,
    currency: {
      min: Math.floor(Math.min(...validCurrencyExposures)),
      max: Math.ceil(Math.max(...validCurrencyExposures))
    }
  }));
}

// הדפס לקונסול לבדיקה
console.log('Risk levels found:', uniqueRiskLevels);
console.log('Exposure ranges:', {
  foreign: exposureRanges.foreign,
  currency: exposureRanges.currency
});
      // קביעת תקופת הדיווח
      if (activeProducts.length > 0 && activeProducts[0].reportPeriod) {
        setReportPeriod(activeProducts [0].reportPeriod);
      }
      
      // מיצוי רשימות לסינון
      // מיין חברות לפי הסדר המוגדר ב-NON_SECTORAL_COMPANIES
      const uniqueCompanies = [...new Set(activeProducts.map(p => p.company))].filter(Boolean);
      
      // הפרד גופים לא סקטוריאליים וסקטוריאליים
      const nonSectoralCompanies = uniqueCompanies.filter(c => NON_SECTORAL_COMPANIES.includes(c));
      const sectoralCompanies = uniqueCompanies.filter(c => !NON_SECTORAL_COMPANIES.includes(c));
      
      // מיין גופים לא סקטוריאליים לפי הסדר המוגדר
      const sortedNonSectoral = nonSectoralCompanies.sort((a, b) => {
        const aIndex = NON_SECTORAL_COMPANIES.indexOf(a);
        const bIndex = NON_SECTORAL_COMPANIES.indexOf(b);
        return aIndex - bIndex;
      });
      
      // מיין גופים סקטוריאליים אלפביתית
      const sortedSectoral = sectoralCompanies.sort();
      
      // שלב: קודם גופים לא סקטוריאליים (בסדר המוגדר), אחר כך סקטוריאליים
      const finalCompanyList = [...sortedNonSectoral, ...sortedSectoral];
      
      const uniqueClassifications = [...new Set(activeProducts.map(p => p.classification))].filter(Boolean).sort();
      const uniqueSpecializations = [...new Set([
        ...activeProducts.map(p => p.originalData.fundInfo?.specialization),
        ...activeProducts.map(p => p.originalData.fundInfo?.subSpecialization)
      ])].filter(Boolean).sort();
      
      setCompanies(finalCompanyList);
      setCategoryClassifications(uniqueClassifications);
     const categorizedTracks = categorizeTracks(uniqueSpecializations);
setSpecializations(categorizedTracks);
      
    } catch (error) {
      console.error('❌ Error loading category data:', error);
      setAllProducts([]);
      setFilteredProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const transformSearchResult = (item) => ({
    id: item.FUND_ID?.toString() || item.id?.toString() || '',
    name: item.FUND_NAME || item.name || 'שם לא זמין',
    company: item.PARENT_COMPANY_NAME || item.MANAGING_CORPORATION || item.CONTROLLING_CORPORATION || item.company || 'חברה לא ידועה',
    classification: item.FUND_CLASSIFICATION || item.classification || '',
    returns: {
      month1: parseFloat(item.MONTH_1_YIELD || item.returns?.month1 || 0),
      ytd: parseFloat(item.YEAR_TO_DATE_YIELD || item.returns?.ytd || 0),
      year1: parseFloat(item.YEAR_1_YIELD || item.returns?.year1 || 0),
      year2: parseFloat(item.YEAR_2_YIELD || item.returns?.year2 || 0),
      year3: parseFloat(item.YEAR_3_YIELD || item.returns?.year3 || 0),
      year4: parseFloat(item.YEAR_4_YIELD || item.returns?.year4 || 0),
      year5: parseFloat(item.YEAR_5_YIELD || item.returns?.year5 || 0)
    },
    fees: {
      management: parseFloat(item.MANAGEMENT_FEE || item.fees?.management || 0),
      deposit: parseFloat(item.fees?.deposit || 0)
    },
    totalAssets: parseFloat(item.TOTAL_ASSETS || item.totalAssets || 0),
    source: item._source || 'government-api',
    sourceLabel: item._sourceLabel || 'נתונים ממשלתיים',
    isActive: item.isActive !== false,
    activityStatus: item.activityStatus || 'פעילה'
  });

  // חיפוש טקסט עם סינון חכם
  const handleTextSearch = async () => {
    if (!searchTerm.trim()) return;

    setShowSuggestions(false);
    setSelectedIndex(-1);

    try {
      setLoading(true);
      const API_BASE = 'https://us-central1-savings-comparison-system.cloudfunctions.net';
      const params = new URLSearchParams({
        query: searchTerm.trim(),
        limit: 1000
      });

      const response = await fetch(`${API_BASE}/searchAllSources?${params.toString()}`);
      const result = await response.json();

      if (result.success) {
        const filteredResults = filterBySelectedCategory(result.results || [], activeTab);
        const transformedResults = filteredResults.map(item => transformSearchResult(item));
    const activeResults = transformedResults.filter(result => result.isActive === true);
setFilteredProducts(activeResults);
      } else {
        setFilteredProducts([]);
      }
    } catch (error) {
      console.error('❌ Search error:', error);
      setFilteredProducts([]);
    } finally {
      setLoading(false);
    }
  };
// פונקציה מתוקנת עם היררכיה נכונה
const normalizeInvestmentTerm = (term) => {
  if (!term) return '';
  
  const normalized = term.toLowerCase().trim();
  
  // מיפוי וריאציות למונחים מנורמלים - סדר חשוב!
  const variations = {
    // עוקבי מדדים צריכים להיות קודם כדי שיזוהו לפני מניות רגילות
    'עוקב מדדים': [
      'עוקב מדדים', 
      'עוקב מדד', 
      'עוקב מדדי', 
      'עוקב מדד s&p 500', 
      'עוקב מדדי מניות', 
      'עוקב מדד מניות',
      'עוקב מדד מניות s&p 500',
      'עוקב מדד מניות s&p',
      'עוקב מדדי אג"ח',
      'עוקב מדדי אג"ח ממשלתיות'
    ],
    // מניות רגילות - בלי עוקבי מדדים
    'מניות': [
      'מניות', 
      'מסלול מניות', 
      'מסלול מניות סחיר', 
      'מניות סחיר'
    ],
    'כספי': [
      'כספי', 
      'שקלי', 
      'שיקלי', 
      'מסלול כספי', 
      'מסלול שקלי', 
      'מסלול כספי (שקלי)'
    ],
    'אגח': [
      'אג"ח', 
      'מסלול אג"ח', 
      'אג"ח ממשלתיות', 
      'מסלול אג"ח ממשלתיות', 
      'אגח', 
      'אגח ממשלתיות'
    ],
    'מעורב': [
      'מעורב', 
      'משולב', 
      'אג"ח עם מניות', 
      'ישראלי ואג"ח עם מניות'
    ],
    'הלכתי': [
      'הלכה', 
      'הלכתי', 
      'מסלול הלכה', 
      'שריעה', 
      'מסלול שריעה'
    ],
    'קיימות': [
      'קיימות', 
      'מסלול קיימות', 
      'טבעתי', 
      'מסלול טבעתי'
    ],
    'כללי': [
      'כללי', 
      'מסלול כללי'
    ]
  };
  
  // בדוק בסדר מוגדר - עוקבי מדדים קודם!
  for (const [category, variants] of Object.entries(variations)) {
    for (const variant of variants) {
      if (normalized.includes(variant) || variant.includes(normalized)) {
        return { category, variants };
      }
    }
  }
  
  return { category: normalized, variants: [normalized] };
};

const checkInvestmentMatch = (searchTerm, fieldValue, product = null) => {
  if (!searchTerm || !fieldValue) return false;
  
  const fieldNormalized = fieldValue.toLowerCase().trim();
  const searchLower = searchTerm.toLowerCase();
  
  // אם מחפשים מסלולים עם הגבלת מניות (עד 25%)
  if (searchLower.includes('עד 25') || searchLower.includes('25%')) {
    // בדוק אם זה עוקב מדדים או מסלול סחיר עם הגבלת מניות
    const indexTerms = [
      'עוקב מדדים', 'עוקב מדד', 'עוקב מדדי', 
      's&p 500', 's&p', 'מדד'
    ];
    
    const hasIndexMatch = indexTerms.some(term => fieldNormalized.includes(term));
    
    // בדוק אם זה מסלול סחיר עם הגבלת מניות
    const hasTradableMatch = fieldNormalized.includes('סחיר') && 
                            fieldNormalized.includes('אג"ח') && 
                            fieldNormalized.includes('מניות');
    
    // אם זה עוקב מדדים או מסלול סחיר עם הגבלת מניות, בדוק גם את חשיפת המניות
    if ((hasIndexMatch || hasTradableMatch) && product) {
      const stockExposure = product.exposures?.stocks;
      // אם יש נתוני חשיפה, בדוק שהם עד 25%
      if (stockExposure !== null && stockExposure !== undefined) {
        return stockExposure <= 25;
      }
      // אם אין נתוני חשיפה, נסה לזהות לפי שם
      const has25Percent = fieldNormalized.includes('עד 25') || 
                           fieldNormalized.includes('25%') ||
                           fieldNormalized.includes('אג"ח עם מניות');
      return has25Percent;
    }
    
    return hasIndexMatch || hasTradableMatch;
  }
  
  // אם מחפשים עוקבי מדדים כללי (בלי הגבלת אחוזים)
  if (searchTerm === 'עוקב מדדים' || searchTerm.includes('עוקב מדד')) {
    const indexTerms = [
      'עוקב מדדים', 'עוקב מדד', 'עוקב מדדי', 
      's&p 500', 's&p', 'מדד'
    ];
    
    return indexTerms.some(term => fieldNormalized.includes(term));
  }
  
  // אם מחפשים מניות רגילות
  if (searchTerm === 'מניות' || searchTerm.includes('מניות')) {
    // קודם בדוק שזה לא עוקב מדדים
    const hasIndexTerms = [
      'עוקב מדדים', 'עוקב מדד', 'עוקב מדדי', 
      's&p 500', 's&p', 'מדד'
    ].some(term => fieldNormalized.includes(term));
    
    // אם יש מונחי מדדים, זה לא מתאים למניות רגילות
    if (hasIndexTerms) return false;
    
    // אחרת, בדוק אם זה מניות
    const stockTerms = ['מניות', 'מסלול מניות'];
    return stockTerms.some(term => fieldNormalized.includes(term));
  }
  
  // אם מחפשים כספי/שקלי
  if (searchTerm === 'כספי' || searchTerm.includes('כספי') || 
      searchTerm === 'שקלי' || searchTerm.includes('שקלי')) {
    const cashTerms = ['כספי', 'שקלי', 'שיקלי', 'מסלול כספי'];
    return cashTerms.some(term => fieldNormalized.includes(term));
  }
  
  // לכל שאר המקרים - התאמה ישירה
  const searchNormalized = normalizeInvestmentTerm(searchTerm);
  return searchNormalized.variants.some(variant => 
    fieldNormalized.includes(variant) || variant.includes(fieldNormalized)
  );
};
// פונקציות ייצוא
  const exportToExcel = () => {
    if (filteredProducts.length === 0) {
      alert('אין נתונים לייצוא');
      return;
    }

    // הכנת הנתונים לייצוא
    const exportData = filteredProducts.map((product, index) => ({
      'מס רים': index + 1,
      'שם הקרן': product.name,
      'חברה מנהלת': product.company,
      'סיווג': product.classification,
      'מזהה': product.id,
      [`תשואה ${getMonthName()} (%)`]: product.returns?.month1?.toFixed(2) || '-',
      'תשואה מתחילת השנה (%)': product.returns?.ytd?.toFixed(2) || '-',
      'תשואה שנה (%)': product.returns?.year1?.toFixed(2) || '-',
      'תשואה שנתיים (%)': product.returns?.year2?.toFixed(2) || '-',
      'תשואה 3 שנים (%)': product.returns?.year3?.toFixed(2) || '-',
      'תשואה 4Y (%)': product.returns?.year4?.toFixed(2) || '-',
      'תשואה 5 שנים (%)': product.returns?.year5?.toFixed(2) || '-',
      'דמי ניהול (%)': product.fees?.management?.toFixed(2) || '-',
      'נכסים מנוהלים': product.totalAssets ? (product.totalAssets / 1000000).toFixed(0) + ' מיליון ₪' : '-',
      'רמת סיכון': product.riskLevel ? `${product.riskLevel.level} - ${product.riskLevel.name}` : '-',
      'חשיפה לחול (%)': product.exposures?.foreign?.toFixed(1) || '-',
      'חשיפה למטח (%)': product.exposures?.currency?.toFixed(1) || '-'
    }));

    // יצירת קובץ CSV
    const headers = Object.keys(exportData[0]);
    const csvContent = [
      headers.join(','),
      ...exportData.map(row => 
        headers.map(header => {
          const value = row[header];
          return typeof value === 'string' && (value.includes(',') || value.includes('"')) 
            ? `"${value.replace(/"/g, '""')}"` 
            : value;
        }).join(',')
      )
    ].join('\n');

    // הורדת הקובץ
    const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${currentCategory.title}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

const exportToPDF = () => {
    if (filteredProducts.length === 0) {
      alert('אין נתונים לייצוא');
      return;
    }

    const printContent = `
      <!DOCTYPE html>
      <html dir="rtl" lang="he">
      <head>
        <meta charset="utf-8">
        <title>${currentCategory.title} - דוח השוואה מלא</title>
        <style>
          @page {
            size: A3 landscape;
            margin: 10mm;
          }
          body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            font-size: 8px;
            line-height: 1.1;
            margin: 0;
            direction: rtl;
          }
          .header {
            text-align: center;
            margin-bottom: 15px;
            border-bottom: 2px solid #3B82F6;
            padding-bottom: 8px;
          }
          .header h1 {
            margin: 0 0 8px 0;
            font-size: 16px;
            color: #1F2937;
          }
          .header p {
            margin: 3px 0;
            color: #6B7280;
            font-size: 10px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
            font-size: 7px;
            table-layout: fixed;
          }
          th, td {
            border: 1px solid #E5E7EB;
            padding: 3px 1px;
            text-align: center;
            vertical-align: middle;
            word-wrap: break-word;
            overflow: hidden;
          }
          th {
            background-color: #F3F4F6;
            font-weight: bold;
            font-size: 7px;
            color: #374151;
            line-height: 1;
          }
          .fund-name {
            text-align: right !important;
            padding: 3px 4px;
          }
          .fund-name .name {
            font-weight: bold;
            font-size: 7px;
            color: #1F2937;
            line-height: 1.1;
          }
          .fund-name .company {
            font-size: 6px;
            color: #6B7280;
            margin-top: 1px;
          }
          .fund-name .id {
            font-size: 5px;
            color: #3B82F6;
            background: #EBF4FF;
            padding: 1px 2px;
            border-radius: 4px;
            margin-top: 1px;
            display: inline-block;
          }
          .positive { 
            color: #059669; 
            font-weight: bold;
          }
          .negative { 
            color: #DC2626; 
            font-weight: bold;
          }
          .neutral {
            color: #6B7280;
          }
          .fees {
            color: #7C2D12;
            font-weight: bold;
          }
          .assets {
            color: #1E40AF;
            font-size: 6px;
          }
          .risk-level {
            background: #FEF3C7;
            color: #92400E;
            border-radius: 6px;
            padding: 1px 2px;
            font-size: 6px;
          }
          .exposure {
            color: #7C3AED;
            font-size: 6px;
          }
          tr:nth-child(even) {
            background-color: #F9FAFB;
          }
          .summary {
            margin-top: 10px;
            padding: 8px;
            background: #F3F4F6;
            border-radius: 6px;
            font-size: 7px;
            page-break-inside: avoid;
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>${currentCategory.title} - דוח השוואה מלא</h1>
          <p>מסורק המסלולים המתקדם | תאריך: ${new Date().toLocaleDateString('he-IL')} | מספר מוצרים: ${filteredProducts.length}</p>
          ${reportPeriod ? `<p>תקופת דיווח: ${reportPeriod}</p>` : ''}
        </div>
        
        <table>
          <thead>
            <tr>
              <th style="width: 3%;">#</th>
              <th style="width: 20%;">פרטי הקרן</th>
              <th style="width: 6%;">${getMonthName()}<br>(%)</th>
              <th style="width: 6%;">מתחילת<br>השנה (%)</th>
              <th style="width: 6%;">שנה<br>(%)</th>
              <th style="width: 6%;">שנתיים<br>(%)</th>
              <th style="width: 6%;">3 שנים<br>(%)</th>
              <th style="width: 6%;">4Y<br>(%)</th>
              <th style="width: 6%;">5 שנים<br>(%)</th>
              <th style="width: 6%;">דמי ניהול<br>(%)</th>
              <th style="width: 8%;">נכסים מנוהלים</th>
              <th style="width: 8%;">רמת סיכון</th>
              <th style="width: 6%;">חשיפה<br>לחו"ל (%)</th>
              <th style="width: 6%;">חשיפה<br>למט"ח (%)</th>
            </tr>
          </thead>
          <tbody>
            ${filteredProducts.map((product, index) => `
              <tr>
                <td>${index + 1}</td>
                <td class="fund-name">
                  <div class="name">${product.name}</div>
                  <div class="company">${product.company}</div>
                  <div class="id">מזהה: ${product.id}</div>
                  ${product.classification ? `<div style="font-size: 6px; color: #6B7280; margin-top: 2px;">${product.classification}</div>` : ''}
                </td>
                <td class="${(product.returns?.month1 || 0) >= 0 ? 'positive' : (product.returns?.month1 || 0) < 0 ? 'negative' : 'neutral'}">
                  ${product.returns?.month1?.toFixed(2) || '-'}
                </td>
                <td class="${(product.returns?.ytd || 0) >= 0 ? 'positive' : (product.returns?.ytd || 0) < 0 ? 'negative' : 'neutral'}">
                  ${product.returns?.ytd?.toFixed(2) || '-'}
                </td>
                <td class="${(product.returns?.year1 || 0) >= 0 ? 'positive' : (product.returns?.year1 || 0) < 0 ? 'negative' : 'neutral'}">
                  ${product.returns?.year1?.toFixed(2) || '-'}
                </td>
                <td class="${(product.returns?.year2 || 0) >= 0 ? 'positive' : (product.returns?.year2 || 0) < 0 ? 'negative' : 'neutral'}">
                  ${product.returns?.year2?.toFixed(2) || '-'}
                </td>
                <td class="${(product.returns?.year3 || 0) >= 0 ? 'positive' : (product.returns?.year3 || 0) < 0 ? 'negative' : 'neutral'}">
                  ${product.returns?.year3?.toFixed(2) || '-'}
                </td>
                <td class="${(product.returns?.year4 || 0) >= 0 ? 'positive' : (product.returns?.year4 || 0) < 0 ? 'negative' : 'neutral'}">
                  ${product.returns?.year4?.toFixed(2) || '-'}
                </td>
                <td class="${(product.returns?.year5 || 0) >= 0 ? 'positive' : (product.returns?.year5 || 0) < 0 ? 'negative' : 'neutral'}">
                  ${product.returns?.year5?.toFixed(2) || '-'}
                </td>
                <td class="fees">
                  ${product.fees?.management?.toFixed(2) || '-'}
                </td>
                <td class="assets">
                  ${product.totalAssets ? 
                    (product.totalAssets >= 1000000000 ? 
                      (product.totalAssets / 1000000000).toFixed(1) + 'B ₪' : 
                      (product.totalAssets / 1000000).toFixed(0) + 'M ₪'
                    ) : '-'
                  }
                </td>
                <td>
                  ${product.riskLevel ? 
                    `<span class="risk-level">${product.riskLevel.level} - ${product.riskLevel.name}</span>` : 
                    '-'
                  }
                </td>
                <td class="exposure">
                  ${product.exposures?.foreign?.toFixed(1) || '-'}
                </td>
                <td class="exposure">
                  ${product.exposures?.currency?.toFixed(1) || '-'}
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        
        <div class="summary">
          <strong>הסברים:</strong><br>
          • תשואות בצבע ירוק - חיוביות | תשואות בצבע אדום - שליליות<br>
          • נכסים מנוהלים: M = מיליון ₪, B = מיליארד ₪<br>
          • רמות סיכון: 1=סולידי, 2=סולידי-מאוזן, 3=מאוזן, 4=מאוזן-אגרסיבי, 5=אגרסיבי<br>
          • חשיפה לחו"ל ומט"ח מתוך סך הנכסים<br>
          • דוח זה נוצר באמצעות מערכת סורק המסלולים המתקדם
        </div>
      </body>
      </html>
    `;

    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
    }, 500);
  };
const getStockExposureFromRiskLevel = (riskLevel) => {
  if (!riskLevel) return null;
  
  const range = RISK_LEVEL_TO_STOCK_EXPOSURE[riskLevel];
  if (range) {
    return (range.min + range.max) / 2; // החזר את האמצע של הטווח
  }
  return null;
};

  const applyFilters = () => {
    let filtered = [...allProducts];
 
    if (filterNonSectoral) {
    filtered = filtered.filter(product => 
      NON_SECTORAL_COMPANIES.includes(product.company)
    );
  }
    if (searchTerm.trim()) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(product => 
        product.name.toLowerCase().includes(searchLower) ||
        product.company.toLowerCase().includes(searchLower) ||
        product.id.includes(searchTerm)
      );
    }
if (filters.establishmentPeriod) {
  filtered = filtered.filter(p => p.classification === filters.establishmentPeriod);
}

    if (filters.company) {
      filtered = filtered.filter(p => p.company === filters.company);
    }
    if (filters.fundType) {
      filtered = filtered.filter(p => p.classification === filters.fundType);
    }
      if (filters.pensionType) {
    if (filters.pensionType === 'מקיפה') {
      filtered = filtered.filter(p => p.isComprehensivePension === true);
    } else if (filters.pensionType === 'משלימה') {
      filtered = filtered.filter(p => p.isComplementaryPension === true);
    }
  }
 if (filters.primaryInvestment || filters.investmentTrack) {
  const investment = filters.primaryInvestment || filters.investmentTrack;
  filtered = filtered.filter(p => {
    const searchableFields = [
      p.originalData.fundInfo?.specialization,
      p.originalData.fundInfo?.subSpecialization,
      p.name,
      p.classification
    ].filter(Boolean);
    
    return searchableFields.some(field => 
      checkInvestmentMatch(investment, field, p)
    );
  });
}
// הסרנו את הפילטר riskLevel כי עכשיו זה חלק מ-stockExposure
if (filters.stockExposure) {
  filtered = filtered.filter(p => {
    const stockExposure = p.exposures?.stocks; // השדה הנכון מה-API שלך
    
    if (stockExposure !== null && stockExposure !== undefined) {
      return stockExposure >= filters.stockExposure.min && stockExposure <= filters.stockExposure.max;
    }
    return false; // אם אין נתונים, לא לכלול
  });
}
if (filters.foreignExposure) {
  filtered = filtered.filter(p => {
    const exposure = p.exposures?.foreign || 0;
    return exposure >= filters.foreignExposure.min && exposure <= filters.foreignExposure.max;
  });
}

if (filters.currencyExposure) {
  filtered = filtered.filter(p => {
    const exposure = p.exposures?.currency || 0;
    return exposure >= filters.currencyExposure.min && exposure <= filters.currencyExposure.max;
  });
}

const sortedFiltered = filtered.sort((a, b) => {
  let aValue, bValue;
  
  if (sortBy === 'managementFee') {
    aValue = a.fees?.management || 0;
    bValue = b.fees?.management || 0;
  } else {
    aValue = a.returns?.[sortBy] || 0;
    bValue = b.returns?.[sortBy] || 0;
  }
  
  return sortOrder === 'desc' ? bValue - aValue : aValue - bValue;
});

    setFilteredProducts(sortedFiltered);
  };
const handleLeadSubmit = async (leadData) => {
  try {
    console.log('📧 Lead submitted from ProductPage:', leadData);
    
    const contactData = {
      name: leadData.name,
      email: '',
      phone: leadData.phone,
      subject: leadData.subject,
      message: leadData.message,
      category: leadData.category,
      source: leadData.source,
      sourceContext: leadData.sourceContext
    };
    
    const contactId = await saveContact(contactData);
    console.log('✅ Lead saved successfully with ID:', contactId);
    
    return true;
  } catch (error) {
    console.error('❌ Error submitting lead:', error);
    throw error;
  }
};
const addToComparison = (product) => {
  if (selectedProducts.length >= 3) {
    alert('ניתן לבחור עד 3 מוצרים להשוואה');
    return;
  }
  
  if (selectedProducts.find(p => p.id === product.id)) {
    alert('המוצר כבר נבחר להשוואה');
    return;
  }
  
  // העבר את כל הנתונים המלאים מ-originalData
  const fullProduct = {
    ...product,
    ...product.originalData, // פרוס את כל הנתונים המלאים
    // שמור גם את הנתונים המעובדים הקיימים
    transformedData: product
  };
  
  setSelectedProducts([...selectedProducts, fullProduct]);
};

  const removeFromComparison = (productId) => {
    setSelectedProducts(selectedProducts.filter(p => p.id !== productId));
  };

  const clearComparison = () => {
    setSelectedProducts([]);
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === 'desc' ? 'asc' : 'desc');
    } else {
      setSortBy(field);
      setSortOrder('desc');
    }
  };
 const displayValue = (value, decimals = 2) => {
    if (value === null || value === undefined || isNaN(value) || value === 0) {
      return '-';
    }
    return value.toFixed(decimals) + '%';
  };
const checkIfRangeMatchesRiskLevel = (stockRange) => {
  if (!stockRange) return null;
  
  // בדיקה גמישה - האם הטווח נמצא בתוך הגבולות של רמת סיכון מסוימת
  for (const [level, range] of Object.entries(RISK_LEVEL_TO_STOCK_EXPOSURE)) {
    // בדוק אם הטווח שהמשתמש בחר נמצא בתוך הטווח המותר של רמת הסיכון
    if (stockRange.min >= range.min && stockRange.max <= range.max) {
      const descriptions = {
        1: '0%-10% מניות',
        2: 'עד 25% מניות', 
        3: 'עד 53% מניות',
        4: 'עד 65% מניות',
        5: '65%-100% מניות'
      };
      
      return {
        level: level,
        displayText: `${level} - ${getRiskLevelName(level)} (${descriptions[level]})`
      };
    }
  }
  return null;
};

// הוסף פונקציה לקבלת שם רמת הסיכון
const getRiskLevelName = (level) => {
  const names = {
    1: 'סולידי',
    2: 'סולידי-מאוזן', 
    3: 'מאוזן',
    4: 'מאוזן-אגרסיבי',
    5: 'אגרסיבי'
  };
  return names[level] || '';
};
  const getMonthName = () => {
    const months = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
    
    if (reportPeriod) {
      const periodStr = reportPeriod.toString();
      if (periodStr.length === 6) {
        const monthNum = parseInt(periodStr.slice(-2));
        if (monthNum >= 1 && monthNum <= 12) {
          return months[monthNum - 1];
        }
      }
    }
    return months[new Date().getMonth()];
  };


const defaultOptionTextMap = {
  'סוג קופה': 'בחר כל סוגי הקופות',
  'חברה מנהלת': 'בחר את כל החברות המנהלות',
  'מסלול השקעה ראשי': 'בחר את כל מסלולי ההשקעה',
  'רמת סיכון': 'בחר כל רמות הסיכון',
  'סוג פנסיה': 'בחר את כל סוגי הפנסיה',
  'תקופת הקמה': 'בחר את כל תקופות ההקמה',
  'גודל הקופה': 'בחר את כל הגדלים',
  'מסלול השקעה': 'בחר את כל מסלולי ההשקעה'
  // הוסף עוד לפי הצורך עם שמות ה-label המדויקים
};


const renderFilterField = (fieldKey) => {
  const field = getFilterFields()[fieldKey];

  // שדה חיפוש משולב עם הצעות - מצומצם
  if (field.type === 'search') {
    return (
      <div key={fieldKey} className="space-y-1 md:space-y-1.5 relative" ref={searchRef}>
        <label className="block text-[10px] md:text-xs font-semibold text-gray-700">{field.label}</label>
        <div className="relative">
          <Search className="absolute left-1.5 md:left-2 top-1/2 transform -translate-y-1/2 h-3 w-3 text-gray-400" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={field.placeholder}
            className="w-full pl-6 md:pl-7 pr-2 py-1.5 md:py-2 text-[11px] md:text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            autoComplete="off"
          />
          
          {searchTerm && (
            <button
              type="button"
              onClick={() => {
                setSearchTerm('');
                setSuggestions([]);
                setShowSuggestions(false);
              }}
              className="absolute left-6 md:left-7 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              <X className="h-2.5 w-2.5 md:h-3 md:w-3" />
            </button>
          )}
        </div>

        {/* רשימת הצעות - מותאמת מובייל */}
        {showSuggestions && (
          <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl z-[9999] max-h-32 md:max-h-48 overflow-y-auto overscroll-contain">
            {loadingSuggestions ? (
              <div className="flex items-center justify-center py-2 md:py-3">
                <Loader className="h-3 w-3 md:h-4 md:w-4 animate-spin text-blue-600 ml-2" />
                <span className="text-gray-600 text-xs md:text-sm">מחפש...</span>
              </div>
            ) : suggestions.length > 0 ? (
              <>
                <div className="px-2 md:px-3 py-1 md:py-2 border-b border-gray-100 bg-gray-50">
                  <div className="flex items-center gap-1 md:gap-2 text-xs text-gray-600">
                    <Search className="h-3 w-3" />
                    <span>תוצאות מסוננות ל{currentCategory.title}</span>
                  </div>
                </div>
                
                {suggestions.map((suggestion, index) => (
                  <button
                    key={`${suggestion.id}-${index}`}
                    onClick={() => selectSuggestion(suggestion)}
                    className={`w-full text-right px-2 md:px-3 py-2 hover:bg-blue-50 border-b border-gray-100 last:border-b-0 transition-colors ${
                      selectedIndex === index ? 'bg-blue-50 border-blue-200' : ''
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex-1 min-w-0">
                        <div className="font-medium text-gray-900 truncate text-xs md:text-sm">
                          {suggestion.name}
                        </div>
                        <div className="flex items-center gap-1 md:gap-2 mt-1">
                          <div className="text-xs text-gray-600 truncate">
                            {suggestion.company}
                          </div>
                          <span className="bg-blue-100 text-blue-700 text-xs px-1 md:px-2 py-1 rounded-full font-medium border border-blue-200">
                            {suggestion.productType}
                          </span>
                        </div>
                      </div>
                      <div className={`text-xs font-bold mr-1 md:mr-2 ${
                        suggestion.year1Return >= 0 ? 'text-green-600' : 'text-red-600'
                      }`}>
                        {suggestion.year1Return.toFixed(1)}%
                      </div>
                    </div>
                  </button>
                ))}
                <div className="px-2 md:px-3 py-1 md:py-2 bg-gray-50 text-center text-xs text-gray-500">
                  {suggestions.length} תוצאות • Enter לבחירה
                </div>
              </>
            ) : searchTerm.length >= 2 ? (
              <div className="px-2 md:px-3 py-2 text-center text-gray-500 text-xs md:text-sm">
                <div>לא נמצאו תוצאות עבור "{searchTerm}"</div>
                <div className="text-xs text-blue-600 mt-1">בקטגוריית {currentCategory.title}</div>
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }

  // שדות בחירה (select) - מותאמים מובייל
  if (field.type === 'select') {
    let options = field.options || [];
    
    if (fieldKey === 'company') {
      options = companies;
    } else if (fieldKey === 'fundType') {
      options = categoryClassifications;
    } else if (fieldKey === 'riskLevel') {
      options = [
        { level: 1, name: 'סולידי', description: '0%-10% מניות' },
        { level: 2, name: 'סולידי-מאוזן', description: 'עד 25% מניות' },
        { level: 3, name: 'מאוזן', description: 'עד 53% מניות' },
        { level: 4, name: 'מאוזן-אגרסיבי', description: 'עד 65% מניות' },
        { level: 5, name: 'אגרסיבי', description: '65%-100% מניות' }
      ].map(risk => 
        `${risk.level} - ${risk.name} (${risk.description})`
      );
    } else if (fieldKey === 'establishmentPeriod') {
      options = categoryClassifications;
    } else if (fieldKey === 'primaryInvestment' || fieldKey === 'investmentTrack') {
      if (activeTab === 'savings-policies') {
        options = field.savingsPolicyTracks || [];
      } else {
        options = specializations;
      }
    }

    const searchableFields = [
      'company', 
      'primaryInvestment', 
      'investmentTrack', 
      'fundType',
      'establishmentPeriod'
    ];
    
    const shouldUseSearchableSelect = searchableFields.includes(fieldKey);

    if (shouldUseSearchableSelect) {
      // React-select עם גדלים מותאמים למובייל
      const selectOptions = options.map(option => ({
        value: option,
        label: option
      }));

      const currentValue = filters[fieldKey] 
        ? { value: filters[fieldKey], label: filters[fieldKey] }
        : null;

      return (
        <div key={fieldKey} className="space-y-1 md:space-y-1.5">
          <div className="flex items-center gap-1">
            <div className={`w-0.5 h-3 md:h-4 rounded-full bg-gradient-to-b ${currentCategory.gradient}`}></div>
            <label className="block text-[10px] md:text-xs font-semibold text-gray-700">{field.label}</label>
            
            {fieldKey === 'riskLevel' && (
              <button
                ref={riskTooltipRef}
                onMouseEnter={() => !isMobile && setShowRiskTooltip(true)}
                onMouseLeave={() => !isMobile && setShowRiskTooltip(false)}
                onClick={() => setShowRiskTooltip(!showRiskTooltip)}
                className="p-0.5 hover:bg-blue-100 rounded-full transition-all duration-200"
                aria-label="מידע על רמות סיכון"
              >
                <HelpCircle className="h-3 w-3 md:h-3.5 md:w-3.5 text-blue-600 hover:text-blue-700" />
              </button>
            )}
          </div>
          
          <Select
            value={currentValue}
            onChange={(selectedOption) => {
              // בדיקה אם זה כפתור החיפוש במובייל
              if (selectedOption && selectedOption.value === '__MOBILE_SEARCH__') {
                setActiveSearchField(fieldKey);
                setShowSearchModal(true);
                return;
              }
              
              const newValue = selectedOption ? selectedOption.value : '';
              setFilters({
                ...filters, 
                [fieldKey]: newValue
              });
            }}
            options={
              isMobile 
                ? [
                    { value: '__MOBILE_SEARCH__', label: '🔍 חיפוש...', isSearchOption: true },
                    ...selectOptions
                  ]
                : selectOptions
            }
            isClearable
            isSearchable={!isMobile}
            placeholder={defaultOptionTextMap[field.label] || `בחר ${field.label}`}
            noOptionsMessage={({ inputValue }) => 
              inputValue ? `לא נמצאו תוצאות עבור "${inputValue}"` : 'אין אפשרויות'
            }
            className="react-select-container react-select-scrollbar"
            classNamePrefix="react-select"
            styles={{
              control: (base, state) => ({
                ...base,
                minHeight: '32px',
                '@media (min-width: 768px)': {
                  minHeight: '36px'
                },
                borderRadius: '8px',
                borderWidth: '1px',
                borderColor: state.isFocused ? '#3B82F6' : '#D1D5DB',
                boxShadow: state.isFocused ? '0 0 0 2px rgba(59, 130, 246, 0.1)' : 'none',
                fontSize: '11px',
                fontWeight: '500',
                '@media (min-width: 768px)': {
                  fontSize: '13px'
                },
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: '#3B82F6'
                }
              }),
              placeholder: (base) => ({
                ...base,
                color: '#9CA3AF',
                fontSize: '11px',
                fontWeight: '400',
                '@media (min-width: 768px)': {
                  fontSize: '13px'
                }
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected 
                  ? '#3B82F6' 
                  : state.isFocused 
                    ? '#DBEAFE' 
                    : 'white',
                color: state.isSelected ? 'white' : '#1F2937',
                fontSize: '11px',
                fontWeight: state.isSelected ? '600' : '500',
                padding: '6px 8px',
                '@media (min-width: 768px)': {
                  fontSize: '13px',
                  padding: '8px 10px'
                },
                cursor: 'pointer',
                transition: 'all 0.15s ease'
              }),
              menu: (base) => ({
                ...base,
                position: 'absolute',
                zIndex: 9999,
                borderRadius: '8px',
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.15)',
                border: '1px solid #E5E7EB',
                fontSize: '11px',
                maxHeight: '200px',
                '@media (min-width: 768px)': {
                  fontSize: '13px',
                  maxHeight: '250px'
                }
              }),
              menuList: (base) => ({
                ...base,
                padding: '4px',
                borderRadius: '8px',
                maxHeight: '200px',
                paddingRight: '8px',
                overflowY: 'auto',
                '@media (min-width: 768px)': {
                  maxHeight: '250px'
                },
                '&::-webkit-scrollbar': {
                  width: '12px'
                },
                '&::-webkit-scrollbar-track': {
                  background: '#F9FAFB',
                  borderRadius: '6px',
                  margin: '4px 0'
                },
                '&::-webkit-scrollbar-thumb': {
                  background: 'linear-gradient(135deg, #3B82F6 0%, #8B5CF6 100%)',
                  borderRadius: '6px',
                  border: '2px solid #F9FAFB'
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: 'linear-gradient(135deg, #2563EB 0%, #7C3AED 100%)'
                }
              })
            }}
          />
          
          {/* טולטיפ לרמת סיכון */}
          {fieldKey === 'riskLevel' && isMobile && showRiskTooltip && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-3 bg-black/50" onClick={() => setShowRiskTooltip(false)}>
              <div className="bg-white rounded-xl p-3 max-w-sm w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
                <RiskLevelLegend filteredProducts={filteredProducts} />
                <button
                  onClick={() => setShowRiskTooltip(false)}
                  className="w-full mt-3 bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg font-medium transition-colors text-sm"
                >
                  הבנתי, תודה!
                </button>
              </div>
            </div>
          )}

          {fieldKey === 'riskLevel' && !isMobile && showRiskTooltip && (
            <TooltipPortal targetRef={riskTooltipRef}>
              <RiskLevelLegend filteredProducts={filteredProducts} />
            </TooltipPortal>
          )}
        </div>
      );
    } else {
      // Select רגיל - עיצוב מצומצם
      return (
        <div key={fieldKey} className="space-y-1 md:space-y-1.5">
          <div className="flex items-center gap-1">
            <div className={`w-0.5 h-3 md:h-4 rounded-full bg-gradient-to-b ${currentCategory.gradient}`}></div>
            <label className="block text-[10px] md:text-xs font-semibold text-gray-700">{field.label}</label>
            
            {fieldKey === 'riskLevel' && (
              <button
                ref={riskTooltipRef}
                onMouseEnter={() => !isMobile && setShowRiskTooltip(true)}
                onMouseLeave={() => !isMobile && setShowRiskTooltip(false)}
                onClick={() => setShowRiskTooltip(!showRiskTooltip)}
                className="p-0.5 hover:bg-blue-100 rounded-full transition-all duration-200"
                aria-label="מידע על רמות סיכון"
              >
                <HelpCircle className="h-3 w-3 md:h-3.5 md:w-3.5 text-blue-600 hover:text-blue-700" />
              </button>
            )}
          </div>
          
          <select
            value={filters[fieldKey] || ''}
            onChange={(e) => {
              const newValue = e.target.value;
              setFilters({...filters, [fieldKey]: newValue});
              
              // הסרנו את הסנכרון כי עכשיו רמת סיכון וחשיפת מניות הם אותו שדה
            }}
            className="w-full px-2 py-1.5 md:py-2 text-[11px] md:text-xs font-medium border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white hover:border-blue-400 transition-all duration-200 cursor-pointer appearance-none bg-no-repeat bg-right pr-6"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
              backgroundPosition: 'left 0.25rem center',
              backgroundSize: '1em 1em'
            }}
          >
            <option value="">{defaultOptionTextMap[field.label] || `בחר ${field.label}`}</option>
            {options.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          
          {/* טולטיפ לרמת סיכון */}
          {fieldKey === 'riskLevel' && isMobile && showRiskTooltip && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-3 bg-black/50" onClick={() => setShowRiskTooltip(false)}>
              <div className="bg-white rounded-xl p-3 max-w-sm w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
                <RiskLevelLegend filteredProducts={filteredProducts} />
                <button
                  onClick={() => setShowRiskTooltip(false)}
                  className="w-full mt-3 bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg font-medium transition-colors text-sm"
                >
                  הבנתי, תודה!
                </button>
              </div>
            </div>
          )}

          {fieldKey === 'riskLevel' && !isMobile && showRiskTooltip && (
            <TooltipPortal targetRef={riskTooltipRef}>
              <RiskLevelLegend filteredProducts={filteredProducts} />
            </TooltipPortal>
          )}
        </div>
      );
    }
  }

  // שדה Exposure Select - Select משולב עם אינפוטים מותאמים אישית (מצומצם)
  if (field.type === 'exposureSelect') {
    const currentValue = filters[fieldKey];
    const isCustom = currentValue && currentValue.isCustom;
    
    // מצא את האופציה הנבחרת
    const getSelectedOption = () => {
      if (!currentValue) return 'כל הטווחים';
      if (isCustom) return '✏️ בחר טווח מותאם אישית';
      
      // מצא אופציה שתואמת לטווח הנוכחי
      const matchingOption = field.options.find(opt => 
        opt.value !== 'custom' && 
        opt.value !== 'all' &&
        opt.value.min === currentValue.min && 
        opt.value.max === currentValue.max
      );
      
      return matchingOption ? matchingOption.label : 'כל הטווחים';
    };
    
    return (
      <div key={fieldKey} className="space-y-1 md:space-y-1.5">
        <div className="flex items-center gap-1">
          <div className={`w-0.5 h-3 md:h-4 rounded-full bg-gradient-to-b ${currentCategory.gradient}`}></div>
          <label className="block text-[10px] md:text-xs font-semibold text-gray-700">{field.label}</label>
        </div>
        
        {/* Select dropdown */}
        <select
          value={getSelectedOption()}
          onChange={(e) => {
            const selectedLabel = e.target.value;
            
            if (selectedLabel === 'כל הטווחים' || selectedLabel === '') {
              // איפוס - הצג הכל
              const newFilters = { ...filters };
              delete newFilters[fieldKey];
              setFilters(newFilters);
              return;
            }
            
            if (selectedLabel === '✏️ בחר טווח מותאם אישית') {
              // מעבר למצב מותאם אישית
              setFilters({
                ...filters,
                [fieldKey]: {
                  min: field.min,
                  max: field.max,
                  isCustom: true
                }
              });
            } else {
              // בחירת אופציה קבועה
              const selectedOption = field.options.find(opt => opt.label === selectedLabel);
              if (selectedOption && selectedOption.value !== 'custom' && selectedOption.value !== 'all') {
                setFilters({
                  ...filters,
                  [fieldKey]: {
                    ...selectedOption.value,
                    isCustom: false
                  }
                });
                
                // אין צורך בסנכרון כי עכשיו רמת סיכון וחשיפת מניות הם אותו שדה
              }
            }
          }}
          className="w-full px-2 py-1.5 md:py-2 text-[11px] md:text-xs font-medium border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white hover:border-blue-400 transition-all duration-200 cursor-pointer appearance-none bg-no-repeat bg-right pr-6"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
            backgroundPosition: 'left 0.25rem center',
            backgroundSize: '1em 1em'
          }}
        >
          {field.options.map(option => (
            <option 
              key={option.label} 
              value={option.label}
            >
              {option.label}
            </option>
          ))}
        </select>
        
        {/* אינפוטים מותאמים אישית - מוצגים רק כשבוחרים "מותאם אישית" */}
        {isCustom && (
          <div className="mt-1.5 px-2 py-2 border border-blue-200 rounded-lg bg-blue-50/30">
            <div className="flex gap-1.5">
              <div className="flex-1">
                <label className="block text-[9px] md:text-[10px] font-semibold text-gray-600 mb-0.5 flex items-center gap-0.5">
                  <span className="text-green-600 text-[10px]">▼</span> מינימום
                </label>
                <input
                  type="number"
                  min={field.min}
                  max={field.max}
                  value={currentValue.min}
                  onChange={(e) => {
                    const newMin = parseFloat(e.target.value);
                    const newRange = {
                      ...currentValue,
                      min: newMin,
                      isCustom: true
                    };
                    setFilters({
                      ...filters,
                      [fieldKey]: newRange
                    });
                    
                    // אין צורך בסנכרון כי עכשיו רמת סיכון וחשיפת מניות הם אותו שדה
                  }}
                  className="w-full px-1.5 py-1 text-[11px] md:text-xs font-semibold text-green-700 border border-green-300 rounded bg-green-50 focus:ring-1 focus:ring-green-400 focus:border-green-400"
                />
              </div>
              <div className="flex-1">
                <label className="block text-[9px] md:text-[10px] font-semibold text-gray-600 mb-0.5 flex items-center gap-0.5">
                  <span className="text-red-600 text-[10px]">▲</span> מקסימום
                </label>
                <input
                  type="number"
                  min={field.min}
                  max={field.max}
                  value={currentValue.max}
                  onChange={(e) => {
                    const newMax = parseFloat(e.target.value);
                    const newRange = {
                      ...currentValue,
                      max: newMax,
                      isCustom: true
                    };
                    setFilters({
                      ...filters,
                      [fieldKey]: newRange
                    });
                    
                    // אין צורך בסנכרון כי עכשיו רמת סיכון וחשיפת מניות הם אותו שדה
                  }}
                  className="w-full px-1.5 py-1 text-[11px] md:text-xs font-semibold text-red-700 border border-red-300 rounded bg-red-50 focus:ring-1 focus:ring-red-400 focus:border-red-400"
                />
              </div>
            </div>
            
            {/* הצגת התאמה לרמת סיכון */}
            {fieldKey === 'stockExposure' && (() => {
              const matchingLevel = checkIfRangeMatchesRiskLevel(currentValue);
              if (matchingLevel) {
                return (
                  <div className="text-[9px] md:text-xs text-center mt-1.5 text-green-600 bg-green-50 px-2 py-0.5 rounded">
                    ✓ תואם לרמת סיכון {matchingLevel.level}
                  </div>
                );
              }
              return null;
            })()}
          </div>
        )}
        
        {/* הצגת הטווח הנבחר */}
        {!isCustom && currentValue && (
          <div className="text-[9px] md:text-[10px] text-gray-600 text-center bg-gray-50 py-1 rounded">
            {currentValue.min}%-{currentValue.max}%
          </div>
        )}
      </div>
    );
  }
  
  // שדה Range - עיצוב משופר
  if (field.type === 'range') {
    const currentValue = filters[fieldKey] || field.max;
    const percentage = ((currentValue - field.min) / (field.max - field.min)) * 100;
    
    return (
      <div key={fieldKey} className="space-y-1.5 md:space-y-3">
        <div className="flex items-center gap-1.5 md:gap-2">
          <div className={`w-1 h-4 md:h-6 rounded-full bg-gradient-to-b ${currentCategory.gradient}`}></div>
          <label className="block text-xs md:text-base font-bold text-gray-800">{field.label}</label>
        </div>
        <div className="relative px-2.5 py-2.5 md:px-4 md:py-5 border-2 border-gray-200 rounded-lg md:rounded-xl bg-gradient-to-br from-white to-blue-50/30 shadow-sm hover:shadow-md hover:border-blue-300 transition-all duration-200">
          <div className="mb-2 md:mb-3">
            <div className={`inline-flex items-center gap-1.5 md:gap-2 px-2.5 py-1.5 md:px-4 md:py-2 bg-gradient-to-r ${currentCategory.gradient} text-white rounded-full font-bold text-sm md:text-xl shadow-md`}>
              <TrendingUp className="h-3.5 w-3.5 md:h-5 md:w-5" />
              {currentValue}%
            </div>
          </div>
          <input
            type="range"
            min={field.min}
            max={field.max}
            step={field.step}
            value={currentValue}
            onChange={(e) => setFilters({...filters, [fieldKey]: parseFloat(e.target.value)})}
            className="w-full h-2 md:h-3 bg-gray-200 rounded-full appearance-none cursor-pointer slider accent-blue-600 hover:accent-blue-700 transition-all"
            style={{
              background: `linear-gradient(to left, #3B82F6 ${percentage}%, #E5E7EB ${percentage}%)`
            }}
          />
          <div className="flex justify-between text-[10px] md:text-sm text-gray-600 mt-1.5 md:mt-2 font-medium">
            <span className="px-1.5 py-0.5 md:px-2 md:py-1 bg-gray-100 rounded text-[10px] md:text-sm">{field.min}%</span>
            <span className="px-1.5 py-0.5 md:px-2 md:py-1 bg-gray-100 rounded text-[10px] md:text-sm">{field.max}%</span>
          </div>
          <div className="text-center text-[10px] md:text-sm text-gray-500 mt-2 md:mt-3 font-medium">
            💎 יציג קופות עם חשיפה עד {currentValue}%
          </div>
        </div>
      </div>
    );
  }

  // שדה Double Range - עיצוב משופר
  if (field.type === 'doubleRange') {
    const currentRange = filters[fieldKey] || { 
      min: field.min, 
      max: field.max 
    };
    
    return (
      <div key={fieldKey} className="space-y-1.5 md:space-y-3">
        <div className="flex items-center gap-1.5 md:gap-2">
          <div className={`w-1 h-4 md:h-6 rounded-full bg-gradient-to-b ${currentCategory.gradient}`}></div>
          <label className="block text-xs md:text-base font-bold text-gray-800">{field.label}</label>
        </div>
        <div className="px-2.5 py-2.5 md:px-4 md:py-5 border-2 border-gray-200 rounded-lg md:rounded-xl bg-gradient-to-br from-white to-purple-50/20 shadow-sm hover:shadow-md hover:border-purple-300 transition-all duration-200">
          {/* Input למינימום ומקסימום */}
          <div className="flex gap-2 md:gap-4 mb-2 md:mb-4">
            <div className="flex-1">
              <label className="block text-[10px] md:text-sm font-bold text-gray-700 mb-1 md:mb-2 flex items-center gap-0.5 md:gap-1">
                <span className="text-green-600 text-xs md:text-base">▼</span> מינימום
              </label>
              <input
                type="number"
                min={field.min}
                max={field.max}
                value={currentRange.min}
                onChange={(e) => {
                  const newRange = {
                    ...currentRange,
                    min: parseFloat(e.target.value)
                  };
                  
                  setFilters({
                    ...filters, 
                    [fieldKey]: newRange
                  });
                  
                  // אין צורך בסנכרון כי עכשיו רמת סיכון וחשיפת מניות הם אותו שדה
                }}
                className="w-full px-2 py-1.5 md:px-3 md:py-2.5 text-xs md:text-base font-bold text-green-700 border-2 border-green-200 rounded-md md:rounded-lg bg-green-50 focus:ring-2 focus:ring-green-500 focus:border-green-500 hover:border-green-400 transition-all"
              />
            </div>
            <div className="flex-1">
              <label className="block text-[10px] md:text-sm font-bold text-gray-700 mb-1 md:mb-2 flex items-center gap-0.5 md:gap-1">
                <span className="text-red-600 text-xs md:text-base">▲</span> מקסימום
              </label>
              <input
                type="number"
                min={field.min}
                max={field.max}
                value={currentRange.max}
                onChange={(e) => {
                  const newRange = {
                    ...currentRange,
                    max: parseFloat(e.target.value)
                  };
                  
                  setFilters({
                    ...filters, 
                    [fieldKey]: newRange
                  });
                  
                  // אין צורך בסנכרון כי עכשיו רמת סיכון וחשיפת מניות הם אותו שדה
                }}
                className="w-full px-2 py-1.5 md:px-3 md:py-2.5 text-xs md:text-base font-bold text-red-700 border-2 border-red-200 rounded-md md:rounded-lg bg-red-50 focus:ring-2 focus:ring-red-500 focus:border-red-500 hover:border-red-400 transition-all"
              />
            </div>
          </div>
          
          {/* הצגת הטווח הנוכחי */}
          <div className="text-center text-xs md:text-sm text-gray-700 font-medium">
            טווח חשיפה: {currentRange.min}% - {currentRange.max}%
          </div>
          
          {/* התראה אם הטווח לא מתאים לרמת סיכון */}
// הסרנו את הבדיקה כי עכשיו רמת סיכון וחשיפת מניות הם אותו שדה
          
          <div className="text-center text-xs text-gray-400">
            יציג קופות עם חשיפה בין {currentRange.min}% ל-{currentRange.max}%
          </div>

{fieldKey === 'stockExposure' && (
  <div className="text-xs text-center mt-1">
    {(() => {
      const matchingLevel = checkIfRangeMatchesRiskLevel(currentRange);
      if (matchingLevel) {
        return (
          <span className="text-green-600 bg-green-50 px-2 py-1 rounded">
            ✓ תואם לרמת סיכון {matchingLevel.level}
          </span>
        );
      }
      return null; // לא מציג כלום אם לא תואם
    })()}
  </div>
)}
        </div>
      </div>
    );
  }
};

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden">
      {/* אלמנטים דקורטיביים ברקע */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-purple-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
      <div className="absolute -bottom-8 left-20 w-96 h-96 bg-pink-300 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>
      
      <div className="container mx-auto px-2 md:px-4 py-4 md:py-8 relative z-10">
        
        {/* כותרת מעוצבת */}
        <div className="text-center mb-8 px-2 relative">
          <div className="inline-block relative">
            <div className="absolute -inset-2 bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-600 rounded-2xl blur-lg opacity-30 animate-pulse"></div>
            <img 
              src="/routeScannerH.png" 
              alt="סורק מסלולים מתקדם" 
              className="relative w-full max-w-4xl mx-auto rounded-2xl shadow-2xl transform hover:scale-[1.02] transition-transform duration-300"
            />
          </div>
      
        </div>
{/* שורת חיפוש עליונה - כמו בדף הבית */}
<div className="mb-4 md:mb-6 px-2">
  <div className="space-y-1.5 md:space-y-2">
    <label className="block text-xs md:text-sm font-semibold text-gray-700">
      חיפוש מוצר - מעבר ישיר לדף המוצר
    </label>
    <div className="flex gap-2">
      <div className="relative flex-1">
        <OptimizedSearchAutocomplete
          selectedCategory={activeTab}
          onSearchSubmit={(results, searchTerm) => {
            // אם יש תוצאה אחת - נווט אליה
            if (results.length === 1) {
              const product = results[0];
              const productCategory = getProductCategory(product) || activeTab;
              navigate(`/product/${productCategory}/${product.id}`);
            }
          }}
          placeholder={`חפש מוצר ב${currentCategory.title}...`}
          loading={false}
        />
      </div>
    </div>
  </div>
</div>

{/* טאבים של קטגוריות - עיצוב משופר */}
<div className="mb-8">
          {/* מובייל - Select dropdown */}
          <div className="md:hidden">
            <div className="space-y-2">
              <div className="flex items-center gap-2 px-2">
                <div className={`w-1 h-5 rounded-full bg-gradient-to-b ${currentCategory.gradient}`}></div>
                <label className="block text-xs font-bold text-gray-800">בחר סוג מוצר</label>
              </div>
              <div className="relative">
                <select
                  value={activeTab}
                  onChange={(e) => {
                    const key = e.target.value;
                    setActiveTab(key);
                    setFilterNonSectoral(false);
                    setSelectedProducts([]);
                    setFilters({});
                    setSearchTerm('');
                    setSuggestions([]);
                    setShowSuggestions(false);
                    setAllProducts([]);
                    setFilteredProducts([]);
                    setCompanies([]);
                    setSpecializations([]);
                    setCategoryClassifications([]);
                    setRiskLevels([]);
                    setReportPeriod(null);
                    setExposureRanges({
                      foreign: { min: 0, max: 100 },
                      currency: { min: 0, max: 100 }
                    });
                    setSelectedRanges({
                      foreign: { min: 0, max: 100 },
                      currency: { min: 0, max: 100 }
                    });
                    setLoading(false);
                    navigate(`/route-scanner/${key}`);
                  }}
                  className="w-full px-3 py-3 pr-10 text-sm font-bold border-2 border-gray-300 rounded-lg bg-white text-gray-800 shadow-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 cursor-pointer appearance-none"
                >
                  {Object.entries(productCategories).map(([key, category]) => (
                    <option 
                      key={key} 
                      value={key}
                      className="text-gray-800 font-semibold py-2"
                    >
                      {category.title}
                    </option>
                  ))}
                </select>
                {/* אייקון מותאם אישית */}
                <div className={`absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none w-6 h-6 rounded-full bg-gradient-to-r ${currentCategory.gradient} flex items-center justify-center`}>
                  <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* דסקטופ - כפתורים */}
          <div className="hidden md:block">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-3 md:p-4">
              <div className="flex flex-wrap gap-2 md:gap-3 justify-center">
                {Object.entries(productCategories).map(([key, category]) => {
                  const IconComponent = category.icon;
                  const isActive = activeTab === key;
                  
                  return (
                    <button
                      key={key}
                      onClick={() => {
                        setActiveTab(key);
                        setFilterNonSectoral(false);
                        setSelectedProducts([]);
                        setFilters({});
                        setSearchTerm('');
                        setSuggestions([]);
                        setShowSuggestions(false);
                        setAllProducts([]);
                        setFilteredProducts([]);
                        setCompanies([]);
                        setSpecializations([]);
                        setCategoryClassifications([]);
                        setRiskLevels([]);
                        setReportPeriod(null);
                        setExposureRanges({
                          foreign: { min: 0, max: 100 },
                          currency: { min: 0, max: 100 }
                        });
                        setSelectedRanges({
                          foreign: { min: 0, max: 100 },
                          currency: { min: 0, max: 100 }
                        });
                        setLoading(false);
                        navigate(`/route-scanner/${key}`);
                      }}
                      className={`relative group overflow-hidden transition-all duration-500 transform ${
                        isActive 
                          ? `bg-gradient-to-br ${category.gradient} text-white shadow-2xl scale-110 z-10` 
                          : 'bg-gradient-to-br from-white to-gray-50 text-gray-700 hover:scale-105 hover:shadow-lg border border-gray-200'
                      } rounded-xl md:rounded-2xl px-4 py-3 md:px-8 md:py-5 flex items-center gap-2 md:gap-3 font-bold text-xs md:text-base min-w-0`}
                    >
                      {isActive && (
                        <>
                          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent transform -skew-x-12 animate-shimmer"></div>
                          <div className="absolute -inset-1 bg-gradient-to-r from-white/40 to-white/0 rounded-2xl blur opacity-40 group-hover:opacity-60 transition-opacity"></div>
                        </>
                      )}
                      
                      <div className={`relative ${isActive ? 'animate-bounce-slow' : ''}`}>
                        <IconComponent className={`h-5 w-5 md:h-6 md:w-6 flex-shrink-0 ${isActive ? 'text-white drop-shadow-lg' : 'text-gray-600 group-hover:text-blue-600'} transition-colors`} />
                      </div>
                      
                      <span className={`relative text-xs md:text-sm font-bold truncate ${isActive ? 'drop-shadow-md' : ''}`}>
                        {category.title}
                      </span>
                        
                      {isActive && (
                        <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-white rounded-full shadow-lg animate-pulse"></div>
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* אזור החיפוש והסינון - עיצוב עתידני מתקדם */}
        <div className="relative group">
          <style>
            {`
              @keyframes shimmer {
                0% { transform: translateX(-100%); }
                100% { transform: translateX(100%); }
              }
              @keyframes gradient-move {
                0% { background-position: 0% 50%; }
                50% { background-position: 100% 50%; }
                100% { background-position: 0% 50%; }
              }
              .animate-gradient {
                background-size: 200% 200%;
                animation: gradient-move 8s ease infinite;
              }
              .animate-shimmer {
                animation: shimmer 3s ease-in-out infinite;
              }
            `}
          </style>
          
          {/* רקע מטאלי דינמי */}
          <div className="absolute -inset-1 bg-gradient-to-r from-slate-400 via-gray-500 via-slate-500 to-gray-400 rounded-3xl opacity-20 blur-2xl group-hover:opacity-30 transition-opacity duration-700 animate-gradient"></div>
          <div className="absolute -inset-0.5 bg-gradient-to-r from-slate-500/20 via-gray-500/20 to-slate-600/20 rounded-2xl opacity-60"></div>
          
          {/* רקע ראשי עם אפקט כסוף מטאלי */}
          <div className="relative bg-gradient-to-br from-slate-300/90 via-gray-400/85 to-slate-500/90 rounded-xl md:rounded-2xl shadow-2xl border border-slate-400/50 backdrop-blur-xl p-3 md:p-4 mb-4 md:mb-6 overflow-hidden animate-gradient" style={{
            background: 'linear-gradient(135deg, rgba(203, 213, 225, 0.95) 0%, rgba(148, 163, 184, 0.9) 25%, rgba(100, 116, 139, 0.9) 50%, rgba(148, 163, 184, 0.9) 75%, rgba(203, 213, 225, 0.95) 100%)',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.5)'
          }}>
            {/* קווים אור דקורטיביים - כסוף */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent opacity-60"></div>
            <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent opacity-60"></div>
            
            {/* נקודות זוהר נעות - כסוף */}
            <div className="absolute top-4 right-4 w-2 h-2 bg-slate-300 rounded-full animate-ping opacity-75"></div>
            <div className="absolute bottom-6 left-6 w-1.5 h-1.5 bg-gray-300 rounded-full animate-pulse opacity-60"></div>
            
          <div className="relative">
            <div className="flex flex-row items-center justify-between gap-2 md:gap-3 mb-2 md:mb-3">
              <div className="flex items-center gap-2">
                <div className={`relative p-1.5 md:p-2 rounded-lg bg-gradient-to-br ${currentCategory.gradient} text-white shadow-lg ring-2 ring-cyan-400/50`}>
                  <currentCategory.icon className="relative h-4 w-4 md:h-5 md:w-5" />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer"></div>
                </div>
                
                <div>
                  <h2 className="text-base md:text-xl font-bold bg-gradient-to-r from-slate-700 via-gray-800 to-slate-700 bg-clip-text text-transparent drop-shadow-lg">
                    {currentCategory.title}
                  </h2>
                  <p className="text-[10px] md:text-xs text-slate-600 mt-0.5 font-medium">גלה את המסלולים המובילים 🚀</p>
                </div>
              </div>
              
              {allProducts.length > 0 && (
                <div>
                  <div className="inline-flex items-center gap-1 md:gap-1.5 bg-gradient-to-r from-slate-500 to-gray-600 text-white px-1.5 md:px-3 py-0.5 md:py-1.5 rounded-full shadow-lg ring-2 ring-slate-400/30 text-[9px] md:text-xs whitespace-nowrap animate-pulse">
                    <span className="font-bold">{filteredProducts.length.toLocaleString()}</span>
                    <span className="opacity-90">מתוך</span>
                    <span className="font-bold">{allProducts.length.toLocaleString()}</span>
                    <Sparkles className="h-2.5 w-2.5 md:h-3 md:w-3 animate-pulse" />
                  </div>
                </div>
              )}
            </div>

  {/* שורת החיפוש והסינון - גריד מותאם מצומצם */}
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-3 mb-3 md:mb-4">
    {currentCategory.filters.map(renderFilterField).filter(Boolean)}
  </div>

  {/* שורת כפתורי מסלולי השקעה - עיצוב משופר - מצומצם במובייל */}
  {(specializations.length > 0 || (activeTab === 'savings-policies' && getFilterFields().investmentTrack?.savingsPolicyTracks)) && (
    <div className="mb-2 md:mb-6 bg-gradient-to-r from-gray-50 to-blue-50/50 rounded-lg md:rounded-2xl p-2 md:p-4 border border-gray-200/50">
      <div className="flex items-center gap-1 md:gap-2 mb-2 md:mb-4">
        <TrendingUp className="h-3 w-3 md:h-5 md:w-5 text-blue-600" />
        <h4 className="text-[10px] md:text-base font-bold text-gray-800">מסלולי השקעה</h4>
        <div className="h-0.5 md:h-1 flex-1 bg-gradient-to-l from-blue-200 to-transparent rounded-full"></div>
      </div>
      
      {/* מובייל - סקרול רוחבי */}
      <div className="md:hidden overflow-x-auto" style={{ scrollbarWidth: 'thin', scrollbarColor: '#9CA3AF #F3F4F6' }}>
        <style>
          {`
            div[style*="scrollbarWidth"]::-webkit-scrollbar {
              height: 6px;
            }
            div[style*="scrollbarWidth"]::-webkit-scrollbar-track {
              background: #F3F4F6;
              border-radius: 10px;
            }
            div[style*="scrollbarWidth"]::-webkit-scrollbar-thumb {
              background: #9CA3AF;
              border-radius: 10px;
            }
          `}
        </style>
        <div className="flex gap-1 pb-1" style={{ width: 'max-content' }}>
          {/* כפתור "הכל" */}
          <button
            onClick={() => {
              const newFilters = { ...filters };
              delete newFilters.primaryInvestment;
              delete newFilters.investmentTrack;
              setFilters(newFilters);
            }}
            className={`relative px-1.5 py-0.5 rounded-full text-[8px] font-semibold transition-all whitespace-nowrap ${
              !filters.primaryInvestment && !filters.investmentTrack
                ? `bg-gradient-to-r ${currentCategory.gradient} text-white shadow-md`
                : 'bg-white text-gray-700 border border-gray-300'
            }`}
          >
            {!filters.primaryInvestment && !filters.investmentTrack && (
              <div className="absolute inset-0 bg-white/20 rounded-full animate-pulse"></div>
            )}
            <span className="relative"> הכל</span>
          </button>
          
          {/* כפתורי מסלולים */}
          {(activeTab === 'savings-policies' 
            ? getFilterFields().investmentTrack?.savingsPolicyTracks?.filter(track => track !== 'כל המסלולים')
            : specializations
          ).map((track) => {
            const isActive = filters.primaryInvestment === track || filters.investmentTrack === track;
            const fieldKey = activeTab === 'savings-policies' ? 'investmentTrack' : 'primaryInvestment';
            
            return (
              <button
                key={track}
                onClick={() => {
                  setFilters({
                    ...filters,
                    [fieldKey]: isActive ? '' : track
                  });
                }}
                className={`relative px-1.5 py-0.5 rounded-full text-[8px] font-semibold transition-all whitespace-nowrap ${
                  isActive
                    ? `bg-gradient-to-r ${currentCategory.gradient} text-white shadow-md`
                    : 'bg-white text-gray-700 border border-gray-300'
                }`}
              >
                {isActive && (
                  <>
                    <div className="absolute inset-0 bg-white/20 rounded-full animate-pulse"></div>
                    <CheckCircle className="absolute top-0 right-0 h-1.5 w-1.5 text-white" />
                  </>
                )}
                <span className="relative">{track}</span>
              </button>
            );
          })}
        </div>
      </div>
      
      {/* דסקטופ - כמה שורות */}
      <div className="hidden md:flex flex-wrap gap-3">
        {/* כפתור "הכל" */}
        <button
          onClick={() => {
            const newFilters = { ...filters };
            delete newFilters.primaryInvestment;
            delete newFilters.investmentTrack;
            setFilters(newFilters);
          }}
          className={`relative px-5 py-2.5 rounded-full text-sm font-bold transition-all transform hover:scale-105 ${
            !filters.primaryInvestment && !filters.investmentTrack
              ? `bg-gradient-to-r ${currentCategory.gradient} text-white shadow-lg`
              : 'bg-white text-gray-700 hover:bg-gray-100 border-2 border-gray-200 hover:border-blue-300'
          }`}
        >
          {!filters.primaryInvestment && !filters.investmentTrack && (
            <div className="absolute inset-0 bg-white/20 rounded-full animate-pulse"></div>
          )}
          <span className="relative flex items-center gap-1"><Cpu className="w-4 h-4" /> הכל</span>
        </button>
        
        {/* כפתורי מסלולים */}
        {(activeTab === 'savings-policies' 
          ? getFilterFields().investmentTrack?.savingsPolicyTracks?.filter(track => track !== 'כל המסלולים')
          : specializations
        ).map((track) => {
          const isActive = filters.primaryInvestment === track || filters.investmentTrack === track;
          const fieldKey = activeTab === 'savings-policies' ? 'investmentTrack' : 'primaryInvestment';
          
          return (
            <button
              key={track}
              onClick={() => {
                setFilters({
                  ...filters,
                  [fieldKey]: isActive ? '' : track
                });
              }}
              className={`relative px-5 py-2.5 rounded-full text-sm font-bold transition-all transform hover:scale-105 ${
                isActive
                  ? `bg-gradient-to-r ${currentCategory.gradient} text-white shadow-lg`
                  : 'bg-white text-gray-700 hover:bg-gray-100 border-2 border-gray-200 hover:border-blue-300'
              }`}
            >
              {isActive && (
                <>
                  <div className="absolute inset-0 bg-white/20 rounded-full animate-pulse"></div>
                  <CheckCircle className="absolute top-0 right-0 h-4 w-4 text-white" />
                </>
              )}
              <span className="relative">{track}</span>
            </button>
          );
        })}
      </div>
    </div>
  )}
{/* כפתור סינון ללא סקטוריאליות */}
{['study-funds', 'pension-savings', 'investment-funds', 'child-savings'].includes(activeTab) && (
  <div className="mb-4 md:mb-6 pt-3 border-t border-gray-200">
    <label className="flex items-center gap-2 cursor-pointer group">
      <input
        type="checkbox"
        checked={filterNonSectoral}
        onChange={(e) => setFilterNonSectoral(e.target.checked)}
        className="w-4 h-4 text-cyan-500 bg-gray-100 border-cyan-400 rounded focus:ring-cyan-500"
      />
      <span className="text-xs md:text-sm font-semibold text-cyan-100 group-hover:text-white drop-shadow-md">
        הצג רק חברות מנהלות גדולות (ללא סקטוריאליות)
      </span>
      <button
        onClick={(e) => {
          e.preventDefault();
          alert(
            'סינון זה מציג רק קרנות מהחברות המנהלות הגדולות והמוכרות:\n\n' +
            NON_SECTORAL_COMPANIES.join(', ') +
            '\n\nקרנות סקטוריאליות קטנות יותר יוסרו מהתוצאות.'
          );
        }}
        className="p-1 hover:bg-cyan-500/30 rounded-full transition-colors"
      >
        <HelpCircle className="h-4 w-4 text-cyan-300 hover:text-white" />
      </button>
    </label>
  </div>
)}
  {/* כפתורי פעולה - עיצוב משופר */}
  <div className="flex flex-row gap-2 md:gap-4">
    <button
      onClick={searchTerm.trim() ? handleTextSearch : () => setFilteredProducts(allProducts)}
      disabled={loading}
      className={`group relative overflow-hidden flex items-center justify-center gap-1.5 md:gap-3 px-3 py-2 md:px-8 md:py-4 bg-gradient-to-r ${currentCategory.gradient} text-white rounded-lg md:rounded-xl font-semibold md:font-bold text-xs md:text-lg shadow-md md:shadow-lg hover:shadow-lg md:hover:shadow-2xl transform hover:scale-105 transition-all duration-300 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent transform -skew-x-12 group-hover:translate-x-full transition-transform duration-1000"></div>
      
      {loading ? (
        <div className="relative animate-spin rounded-full h-3 w-3 md:h-5 md:w-5 border-b-2 border-white"></div>
      ) : (
        <Search className="relative h-3 w-3 md:h-6 md:w-6 group-hover:scale-110 transition-transform" />
      )}
      <span className="relative text-[10px] md:text-sm">
        {searchTerm.trim() ? '🔍 חפש עכשיו' : '✨ הצג הכל'}
      </span>
      <Sparkles className="relative h-3 w-3 md:h-4 md:w-4 animate-pulse" />
    </button>
    
    <button
      onClick={() => {
        setSearchTerm('');
        setFilters({});
        setSuggestions([]);
        setShowSuggestions(false);
        setFilteredProducts([]);
        setFilterNonSectoral(false);
      }}
      className="group flex items-center justify-center gap-1 md:gap-2 px-3 py-2 md:px-8 md:py-4 bg-white border border-gray-300 md:border-2 text-gray-700 rounded-lg md:rounded-xl font-semibold md:font-bold text-xs md:text-lg hover:bg-red-50 hover:border-red-300 hover:text-red-600 shadow-sm md:shadow-md hover:shadow-md md:hover:shadow-lg transform hover:scale-105 transition-all duration-300"
    >
      <X className="h-3 w-3 md:h-6 md:w-6 group-hover:rotate-90 transition-transform duration-300" />
      <span className="text-[10px] md:text-sm">נקה הכל</span>
    </button>
  </div>
          </div>
          </div>
        </div>
        
        {/* פאנל השוואה - עיצוב משופר */}
        {selectedProducts.length > 0 && (
         <div className="relative bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 rounded-3xl shadow-2xl p-6 md:p-8 border-2 border-green-200 mb-8 overflow-hidden">
            <div className="absolute -inset-1 bg-gradient-to-r from-green-500 via-emerald-500 to-teal-500 rounded-3xl opacity-10 blur-2xl animate-pulse"></div>
            
            <div className="relative">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 mb-6">
                <div className="flex items-center gap-3">
                  <div className="p-3 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl shadow-lg">
                    <Sparkles className="h-6 w-6 text-white animate-spin-slow" />
                  </div>
                  <div>
                    <h3 className="text-xl md:text-2xl font-extrabold bg-gradient-to-r from-green-700 to-emerald-600 bg-clip-text text-transparent">
                      מוצרים נבחרים להשוואה
                    </h3>
                    <p className="text-sm text-gray-600 mt-1">
                      {selectedProducts.length} מתוך 3 מוצרים • בחר עוד {3 - selectedProducts.length}
                    </p>
                  </div>
                </div>
                <button
                  onClick={clearComparison}
                  className="group flex items-center gap-2 px-4 py-2 bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-700 rounded-xl font-bold transition-all transform hover:scale-105 shadow-md"
                >
                  <X className="h-4 w-4 group-hover:rotate-90 transition-transform" />
                  <span className="text-xs">נקה הכל</span>
                </button>
              </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
              {selectedProducts.map((product, index) => (
                <div 
                  key={product.id} 
                  className="border-2 border-green-200 rounded-xl p-4 relative bg-green-50 hover:bg-green-100 transition-all duration-300"
                >
                  <button
                    onClick={() => removeFromComparison(product.id)}
                    className="absolute top-3 left-3 text-red-500 hover:text-red-700 hover:bg-red-100 rounded-full p-1 transition-all"
                  >
                    <X className="h-4 w-4" />
                  </button>
                  
                  <div className="pl-8">
                    <div className="flex items-center gap-2 mb-2">
                      <div className={`p-1.5 rounded-lg bg-gradient-to-r ${currentCategory.gradient} text-white`}>
                        <currentCategory.icon className="h-4 w-4" />
                      </div>
                      <span className="text-xs font-medium text-green-700 bg-green-200 px-2 py-1 rounded-full">
                        #{index + 1}
                      </span>
                    </div>
                    
                    <h4 className="font-bold text-gray-800 text-sm leading-tight mb-2">
                      {product.name}
                    </h4>
                    <p className="text-gray-600 text-xs mb-2">{product.company}</p>
                    
                    <div className="space-y-1">
                      <span className="inline-block px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full">
                        {product.classification}
                      </span>
                      
                      {product.returns?.year1 && (
                        <div className="text-xs text-green-700 font-medium">
                          תשואה שנתית: {product.returns.year1.toFixed(2)}%
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
              
              {/* מקום פנוי למוצר נוסף */}
              {selectedProducts.length < 3 && (
                <div className="border-2 border-dashed border-gray-300 rounded-xl p-4 flex flex-col items-center justify-center text-gray-400 bg-gray-50 min-h-[140px]">
                  <Plus className="h-8 w-8 mb-2" />
                  <span className="text-sm font-medium">הוסף מוצר נוסף</span>
                  <span className="text-xs">עד {3 - selectedProducts.length} נוספים</span>
                </div>
              )}
            </div>
            
            <div className="text-center">
              <button
                onClick={goToComparison}
                disabled={selectedProducts.length < 2}
                className={`flex items-center gap-3 mx-auto px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300 ${
                  selectedProducts.length >= 2
                    ? `bg-gradient-to-r ${currentCategory.gradient} text-white hover:scale-105 shadow-lg hover:shadow-xl animate-pulse`
                    : 'bg-gray-200 text-gray-500 cursor-not-allowed'
                }`}
              >
                <BarChart3 className="h-6 w-6" />
                השווה עכשיו
                <ArrowRight className="h-6 w-6" />
              </button>
              
              {selectedProducts.length < 2 && (
                <p className="text-gray-500 text-sm mt-3 flex items-center justify-center gap-1">
                  <AlertCircle className="h-4 w-4" />
                  יש לבחור לפחות 2 מוצרים להשוואה
                </p>
              )}
              
              {selectedProducts.length >= 2 && (
                <p className="text-green-600 text-sm mt-3 flex items-center justify-center gap-1">
                  <CheckCircle className="h-4 w-4" />
                  מוכן להשוואה! לחץ על הכפתור למעלה
                </p>
              )}
            </div>
          </div>
          </div>
        )}

        {/* טבלת המוצרים - עיצוב משופר */}
        {loading ? (
          <div className="relative bg-gradient-to-br from-white to-blue-50 rounded-3xl shadow-2xl p-12 text-center border border-blue-100 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-100/0 via-blue-100/50 to-blue-100/0 animate-shimmer"></div>
            <div className="relative space-y-4">
              <div className="flex justify-center">
                <div className="relative">
                  <div className="absolute inset-0 bg-blue-500 rounded-full blur-xl opacity-50 animate-pulse"></div>
                  <Loader className="relative h-16 w-16 animate-spin text-blue-600" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800">טוען נתונים...</h3>
              <p className="text-sm text-gray-600">מחפש את המסלולים הטובים ביותר עבורך 🔍</p>
              <div className="flex justify-center gap-2 mt-4">
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-purple-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
                <div className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
              </div>
            </div>
          </div>
        ) : filteredProducts.length > 0 ? (
    <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden mb-8 border border-gray-100">
  {/* כפתורי ייצוא */}
{/* כפתורי ייצוא - רספונסיבי */}
  <div className="px-2 md:px-4 py-1.5 md:py-3 bg-gray-50 border-b border-gray-200">
    <div className="flex flex-row items-center justify-between gap-1.5 md:gap-3">
      {/* כותרת ומספר מוצרים */}
      <div className="flex items-center gap-1 md:gap-2 flex-wrap">
        <h3 className="text-[10px] md:text-base font-semibold text-gray-800">תוצאות</h3>
        <span className="bg-blue-100 text-blue-800 px-1 md:px-2 py-0.5 md:py-1 rounded-full text-[9px] md:text-xs font-medium">
          {filteredProducts.length.toLocaleString()} מתוך {allProducts.length.toLocaleString()}
        </span>
        <span className="bg-green-100 text-green-800 px-1 md:px-2 py-0.5 md:py-1 rounded-full text-[9px] md:text-xs font-medium">
          תשואות שנה - 5 שנים
        </span>
      </div>
      
      {/* כפתורי ייצוא */}
      <div className="flex flex-row items-center gap-1 md:gap-2">
        <span className="hidden md:inline text-xs text-gray-600">ייצא:</span>
        
        <div className="flex gap-1 md:gap-2">
          <button
            onClick={exportToExcel}
            className="flex items-center justify-center gap-0.5 md:gap-1 px-1.5 md:px-3 py-1 md:py-1.5 bg-green-600 hover:bg-green-700 text-white rounded md:rounded-lg font-medium transition-colors shadow-sm text-[10px] md:text-xs"
          >
            <FileSpreadsheet className="h-2.5 w-2.5 md:h-4 md:w-4" />
            <span>Excel</span>
          </button>
          
          <button
            onClick={exportToPDF}
            className="flex items-center justify-center gap-0.5 md:gap-1 px-1.5 md:px-3 py-1 md:py-1.5 bg-red-600 hover:bg-red-700 text-white rounded md:rounded-lg font-medium transition-colors shadow-sm text-[10px] md:text-xs"
          >
            <FileText className="h-2.5 w-2.5 md:h-4 md:w-4" />
            <span>PDF</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <style>
    {`
      .custom-scrollbar::-webkit-scrollbar {
        height: 8px;
      }
      .custom-scrollbar::-webkit-scrollbar-track {
        background: #F3F4F6;
        border-radius: 10px;
      }
      .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #9CA3AF;
        border-radius: 10px;
      }
      .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: #6B7280;
      }
      
      /* Scrollbar styles for react-select dropdown menus */
      .react-select-scrollbar .react-select__menu-list::-webkit-scrollbar {
        width: 12px;
      }
      .react-select-scrollbar .react-select__menu-list::-webkit-scrollbar-track {
        background: #F9FAFB;
        border-radius: 6px;
        margin: 4px;
      }
      .react-select-scrollbar .react-select__menu-list::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #3B82F6 0%, #8B5CF6 100%);
        border-radius: 6px;
        border: 2px solid #F9FAFB;
      }
      .react-select-scrollbar .react-select__menu-list::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #2563EB 0%, #7C3AED 100%);
      }
    `}
  </style>
  <div className="overflow-x-auto custom-scrollbar" style={{ scrollbarWidth: 'thin', scrollbarColor: '#9CA3AF #F3F4F6' }}>
              <table className="w-full text-xs md:text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-1 md:px-3 py-1.5 md:py-2 text-center font-semibold md:font-bold text-gray-700 text-[10px] md:text-sm">השווה</th>
                    <th className="px-2 md:px-4 py-1.5 md:py-2 text-right font-semibold md:font-bold text-gray-700 text-[10px] md:text-sm sticky right-0 bg-gray-50 z-10">שם הקרן</th>
                    <th className={`px-1 md:px-3 py-1.5 md:py-2 text-center ${sortBy === 'month1' ? 'bg-blue-100' : ''}`}>
                      <button 
                        onClick={() => handleSort('month1')}
                        className={`font-semibold md:font-bold text-[9px] md:text-xs ${sortBy === 'month1' ? 'text-blue-700' : 'text-gray-700 hover:text-blue-600'}`}
                      >
                        {getMonthName()}
                        {sortBy === 'month1' && (sortOrder === 'desc' ? ' ↓' : ' ↑')}
                      </button>
                    </th>
                    <th className={`px-1 md:px-3 py-1.5 md:py-2 text-center ${sortBy === 'ytd' ? 'bg-blue-100' : ''}`}>
                      <button 
                        onClick={() => handleSort('ytd')}
                        className={`font-semibold md:font-bold text-[9px] md:text-xs ${sortBy === 'ytd' ? 'text-blue-700' : 'text-gray-700 hover:text-blue-600'}`}
                      >
                        <span className="hidden md:inline">מתחילת השנה</span>
                        <span className="md:hidden">YTD</span>
                        {sortBy === 'ytd' && (sortOrder === 'desc' ? ' ↓' : ' ↑')}
                      </button>
                    </th>
                    <th className={`px-1 md:px-3 py-1.5 md:py-2 text-center ${sortBy === 'year1' ? 'bg-blue-100' : ''}`}>
                      <button 
                        onClick={() => handleSort('year1')}
                        className={`font-semibold md:font-bold text-[9px] md:text-xs ${sortBy === 'year1' ? 'text-blue-700' : 'text-gray-700 hover:text-blue-600'}`}
                      >
                        <span className="hidden md:inline">שנה</span>
                        <span className="md:hidden">1Y</span>
                        {sortBy === 'year1' && (sortOrder === 'desc' ? ' ↓' : ' ↑')}
                      </button>
                    </th>
                    <th className={`px-1 md:px-3 py-1.5 md:py-2 text-center ${sortBy === 'year2' ? 'bg-blue-100' : ''}`}>
                      <button 
                        onClick={() => handleSort('year2')}
                        className={`font-semibold md:font-bold text-[9px] md:text-xs ${sortBy === 'year2' ? 'text-blue-700' : 'text-gray-700 hover:text-blue-600'}`}
                      >
                        <span className="hidden md:inline">שנתיים</span>
                        <span className="md:hidden">2Y</span>
                        {sortBy === 'year2' && (sortOrder === 'desc' ? ' ↓' : ' ↑')}
                      </button>
                    </th>
                    <th className={`px-1 md:px-3 py-1.5 md:py-2 text-center ${sortBy === 'year3' ? 'bg-blue-100' : ''}`}>
                      <button 
                        onClick={() => handleSort('year3')}
                        className={`font-semibold md:font-bold text-[9px] md:text-xs ${sortBy === 'year3' ? 'text-blue-700' : 'text-gray-700 hover:text-blue-600'}`}
                      >
                        <span className="hidden md:inline">3 שנים</span>
                        <span className="md:hidden">3Y</span>
                        {sortBy === 'year3' && (sortOrder === 'desc' ? ' ↓' : ' ↑')}
                      </button>
                    </th>
                    <th className={`px-1 md:px-3 py-1.5 md:py-2 text-center ${sortBy === 'year4' ? 'bg-blue-100' : ''}`}>
                      <button
                        onClick={() => handleSort('year4')}
                        className={`font-semibold md:font-bold text-[9px] md:text-xs ${sortBy === 'year4' ? 'text-blue-700' : 'text-gray-700 hover:text-blue-600'}`}
                      >
                        <span className="hidden md:inline">4 שנים</span>
                        <span className="md:hidden">4Y</span>
                        {sortBy === 'year4' && (sortOrder === 'desc' ? ' ↓' : ' ↑')}
                      </button>
                    </th>
                    <th className={`px-1 md:px-3 py-1.5 md:py-2 text-center ${sortBy === 'year5' ? 'bg-blue-100' : ''}`}>
                      <button 
                        onClick={() => handleSort('year5')}
                        className={`font-semibold md:font-bold text-[9px] md:text-xs ${sortBy === 'year5' ? 'text-blue-700' : 'text-gray-700 hover:text-blue-600'}`}
                      >
                        <span className="hidden md:inline">5 שנים</span>
                        <span className="md:hidden">5Y</span>
                        {sortBy === 'year5' && (sortOrder === 'desc' ? ' ↓' : ' ↑')}
                      </button>
                    </th>
                    <th className={`px-1 md:px-3 py-1.5 md:py-2 text-center ${sortBy === 'managementFee' ? 'bg-blue-100' : ''}`}>
  <button
    onClick={() => handleSort('managementFee')}
    className={`font-semibold md:font-bold text-[9px] md:text-xs ${sortBy === 'managementFee' ? 'text-blue-700' : 'text-gray-700 hover:text-blue-600'}`}
  >
    דמי ניהול
    {sortBy === 'managementFee' && (sortOrder === 'desc' ? ' ↓' : ' ↑')}
  </button>
</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {filteredProducts.map((product, index) => (
                 <tr 
    key={product.id} 
   className={`transition-colors ${
  index % 2 === 0 
    ? 'bg-white hover:bg-gray-50' 
    : 'bg-gray-200 hover:bg-gray-150'
}`}
  >
                      {/* כפתור השווה */}
                      <td className="px-1 md:px-3 py-1.5 md:py-2.5 text-center">
                        <button
                          onClick={() => addToComparison(product)}
                          disabled={selectedProducts.find(p => p.id === product.id)}
                          className={`flex items-center gap-0.5 md:gap-1 px-1.5 md:px-3 py-1 md:py-1.5 rounded-md md:rounded-lg text-[9px] md:text-xs font-medium transition-all ${
                            selectedProducts.find(p => p.id === product.id)
                              ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                              : `bg-gradient-to-r ${currentCategory.gradient} text-white hover:scale-105`
                          }`}
                        >
                          {selectedProducts.find(p => p.id === product.id) ? (
                            <>
                              <CheckCircle className="h-2 w-2 md:h-3 md:w-3" />
                              <span className="hidden md:inline">נבחר</span>
                              <span className="md:hidden">✓</span>
                            </>
                          ) : (
                            <>
                              <Plus className="h-2 w-2 md:h-3 md:w-3" />
                              <span className="hidden md:inline">השווה</span>
                              <span className="md:hidden">+</span>
                            </>
                          )}
                        </button>
                      </td>

                      {/* שם הקרן */}
             {/* שם הקרן */}
<td className="px-2 md:px-4 py-1.5 md:py-2.5 sticky right-0 bg-inherit z-10">
  <div className="text-right">
    <div className="font-medium text-gray-900 text-[10px] md:text-sm leading-tight">
      <a 
        href={`https://www.gemelnet.ai/product/${getCategoryApiId(activeTab)}/${product.id}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 hover:text-blue-800 hover:underline transition-colors"
      >
        {product.name}
      </a>
    </div>
    <div className="text-[9px] md:text-xs text-gray-600 mt-0.5">
      {product.company}
    </div>
    {product.classification && (
      <div className="text-[8px] md:text-xs text-blue-600 bg-blue-50 inline-block px-1 md:px-2 py-0.5 rounded mt-0.5">
        מזהה: {product.id}
      </div>
    )}
  </div>
</td>

                      {/* תשואות */}
                      <td className={`px-1 md:px-3 py-1.5 md:py-2.5 text-center ${sortBy === 'month1' ? 'bg-blue-100' : ''}`}>
                        <span className={`font-medium text-[10px] md:text-sm ${
                          (product.returns?.month1 || 0) >= 0 ? 'text-green-600' : 'text-red-600'
                        }`}>
                          {displayValue(product.returns?.month1)}
                        </span>
                      </td>

                      <td className={`px-1 md:px-3 py-1.5 md:py-2.5 text-center ${sortBy === 'ytd' ? 'bg-blue-100' : ''}`}>
                        <span className={`font-medium text-[10px] md:text-sm ${
                          (product.returns?.ytd || 0) >= 0 ? 'text-blue-600' : 'text-red-600'
                        }`}>
                          {displayValue(product.returns?.ytd)}
                        </span>
                      </td>

                      <td className={`px-1 md:px-3 py-1.5 md:py-2.5 text-center ${sortBy === 'year1' ? 'bg-blue-100' : ''}`}>
                        <span className={`font-medium text-[10px] md:text-sm ${
                          (product.returns?.year1 || 0) >= 0 ? 'text-purple-600' : 'text-red-600'
                        }`}>
                          {displayValue(product.returns?.year1)}
                        </span>
                      </td>

                      <td className={`px-1 md:px-3 py-1.5 md:py-2.5 text-center ${sortBy === 'year2' ? 'bg-blue-100' : ''}`}>
                        <span className={`font-medium text-[10px] md:text-sm ${
                          (product.returns?.year2 || 0) >= 0 ? 'text-orange-600' : 'text-red-600'
                        }`}>
                          {displayValue(product.returns?.year2)}
                        </span>
                      </td>

                      <td className={`px-1 md:px-3 py-1.5 md:py-2.5 text-center ${sortBy === 'year3' ? 'bg-blue-100' : ''}`}>
                        <span className={`font-medium text-[10px] md:text-sm ${
                          (product.returns?.year3 || 0) >= 0 ? 'text-indigo-600' : 'text-red-600'
                        }`}>
                          {displayValue(product.returns?.year3)}
                        </span>
                      </td>

                      <td className={`px-1 md:px-3 py-1.5 md:py-2.5 text-center ${sortBy === 'year4' ? 'bg-blue-100' : ''}`}>
                        <span className={`font-medium text-[10px] md:text-sm ${
                          (product.returns?.year4 || 0) >= 0 ? 'text-teal-600' : 'text-red-600'
                        }`}>
                          {displayValue(product.returns?.year4)}
                        </span>
                      </td>

                      <td className={`px-1 md:px-3 py-1.5 md:py-2.5 text-center ${sortBy === 'year5' ? 'bg-blue-100' : ''}`}>
                        <span className={`font-medium text-[10px] md:text-sm ${
                          (product.returns?.year5 || 0) >= 0 ? 'text-pink-600' : 'text-red-600'
                        }`}>
                          {displayValue(product.returns?.year5)}
                        </span>
                      </td>
<td className={`px-1 md:px-3 py-1.5 md:py-2.5 text-center ${sortBy === 'managementFee' ? 'bg-blue-100' : ''}`}>
  <span className="font-medium text-[10px] md:text-sm text-orange-600">
    {product.fees?.management !== null && 
     product.fees?.management !== undefined && 
     product.fees?.management > 0
      ? `${product.fees.management.toFixed(2)}%` 
      : '-'}
  </span>
</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

         
          </div>
        ) : !loading && allProducts.length > 0 ? (
          <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
            <div className="text-gray-500">
              <Search className="h-12 w-12 mx-auto mb-4 text-gray-300" />
              <p className="text-lg mb-2">חפש או השתמש בסינונים</p>
              <p className="text-sm">לחץ על "הצג הכל" כדי לראות את כל המוצרים בקטגוריה</p>
            </div>
          </div>
        ) : !loading ? (
          <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
            <div className="text-gray-500">
              <AlertCircle className="h-12 w-12 mx-auto mb-4 text-gray-300" />
              <p className="text-lg mb-2">אין נתונים זמינים</p>
              <p className="text-sm">בחר קטגוריה אחרת או נסה שוב מאוחר יותר</p>
            </div>
          </div>
        ) : null}

      
      </div>
            <LeadModal
  isOpen={isLeadModalOpen}
  onClose={() => setIsLeadModalOpen(false)}
  onSubmit={handleLeadSubmit}
  sourceContext={currentLeadContext}
/>

      {/* Modal חיפוש במובייל */}
      {showSearchModal && activeSearchField && (() => {
        const field = currentCategory.filters.find(f => f.key === activeSearchField);
        let options = field?.options || [];
        
        if (activeSearchField === 'company') {
          options = companies;
        } else if (activeSearchField === 'fundType') {
          options = categoryClassifications;
        } else if (activeSearchField === 'establishmentPeriod') {
          options = categoryClassifications;
        } else if (activeSearchField === 'primaryInvestment' || activeSearchField === 'investmentTrack') {
          if (activeTab === 'savings-policies') {
            options = field?.savingsPolicyTracks || [];
          } else {
            options = specializations;
          }
        }
        
        const selectOptions = options.map(option => ({
          value: option,
          label: option
        }));
        
        return (
          <div className="fixed inset-0 z-[10000] flex items-start justify-center bg-black/50 p-4">
            <div className="bg-white rounded-lg w-full max-w-md mt-20 shadow-xl">
              <div className="p-4 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-lg font-bold">חיפוש {field?.label}</h3>
                <button
                  onClick={() => {
                    setShowSearchModal(false);
                    setActiveSearchField(null);
                    setSearchInputValues(prev => ({ ...prev, [activeSearchField]: '' }));
                  }}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
              
              <div className="p-4">
                <input
                  type="text"
                  autoFocus
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-base"
                  placeholder="הקלד לחיפוש..."
                  value={searchInputValues[activeSearchField] || ''}
                  onChange={(e) => {
                    setSearchInputValues(prev => ({
                      ...prev,
                      [activeSearchField]: e.target.value
                    }));
                  }}
                />
                
                <div className="mt-4 max-h-96 overflow-y-auto">
                  {selectOptions
                    .filter(option => 
                      !searchInputValues[activeSearchField] || 
                      option.label.toLowerCase().includes(searchInputValues[activeSearchField].toLowerCase())
                    )
                    .map(option => (
                      <button
                        key={option.value}
                        onClick={() => {
                          setFilters({
                            ...filters,
                            [activeSearchField]: option.value
                          });
                          setShowSearchModal(false);
                          setActiveSearchField(null);
                          setSearchInputValues(prev => ({ ...prev, [activeSearchField]: '' }));
                        }}
                        className="w-full text-right px-4 py-3 hover:bg-blue-50 border-b border-gray-100 text-sm"
                      >
                        {option.label}
                      </button>
                    ))}
                </div>
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
};

export default RouteScanner;
